const de = {
  "nav.home": "Start",
  "nav.browse": "Angebote entdecken",
  "nav.nearExpiry": "Läuft bald ab",
  "nav.categories": "Kategorien",
  "nav.businesses": "Geschäfte",
  "nav.favourites": "Favoriten",
  "nav.following": "Abos",
  "follows.title": "Abos",
  "follows.subtitle": "Alle Geschäfte und Orte, denen du folgst — an einem Ort. Wir melden uns bei neuen Angeboten.",
  "follows.businesses": "Geschäfte, denen du folgst ({n})",
  "follows.places": "Orte, denen du folgst ({n})",
  "follows.followPlace": "Diesem Ort folgen",
  "follows.following": "Folgt",
  "follows.nowFollowing": "Du folgst {name}",
  "follows.unfollowed": "{name} nicht mehr gefolgt",
  "follows.placeNudge": "Wir melden uns, sobald ein Geschäft hier ein Angebot einstellt.",
  "follows.signIn": "Melde dich an, um Geschäften und Orten zu folgen",
  "follows.createAccount": "Kostenloses Konto erstellen",
  "follows.emptyTitle": "Du folgst noch niemandem",
  "follows.emptyBody": "Folge einem Geschäft oder einem Einkaufszentrum und neue Angebote kommen zu dir.",
  "nav.myDeals": "Meine Angebote",
  "nav.lytemap": "LyteMap",
  "nav.postDeal": "Angebot einstellen",
  "nav.analytics": "Statistiken",
  "nav.admin": "Admin",
  "nav.ourStory": "Unsere Geschichte",
  "nav.myAccount": "Mein Konto",
  "nav.pricing": "Preise",

  "brand.tagline": "Mehr sparen. Weniger wegwerfen.",

  "sidebar.businessLogin": "Anmelden",
  "sidebar.signupFree": "Neu hier? Kostenlos registrieren",
  "sidebar.proActive": "Pro aktiv",
  "sidebar.until": "Bis {date}",
  "sidebar.growPro": "Mit Pro wachsen",
  "sidebar.growProDesc": "Hervorgehobene Platzierung, unbegrenzte Angebote und volle Statistiken.",
  "sidebar.goPremium": "Premium holen",

  "topbar.searchPlaceholder": "Angebote, Geschäfte oder Kategorien suchen...",
  "topbar.aiPlaceholder": "Frag die KI: günstiges Abendessen in der Nähe…",
  "topbar.askAi": "KI fragen",
  "topbar.nearMe": "In meiner Nähe",
  "topbar.anywhere": "Überall",
  "topbar.country": "Land",
  "topbar.city": "Stadt",
  "topbar.allCities": "Alle Städte",
  "topbar.useMyLocation": "Meinen Standort verwenden",
  "topbar.privacyNote": "Wir nutzen den Standort deines Geräts, nicht deine IP-Adresse — das bleibt privat und stimmt auch mit VPN.",
  "topbar.typePlace": "oder Stadt bzw. Ort eingeben…",
  "topbar.clearEverywhere": "Zurücksetzen — Angebote überall zeigen",
  "topbar.notifications": "Benachrichtigungen",
  "topbar.more": "Mehr Optionen",
  "topbar.darkMode": "Dunkelmodus",
  "topbar.lightMode": "Hellmodus",
  "topbar.recent": "{n} neue",
  "topbar.noNotifs": "Noch keine Benachrichtigungen.",
  "topbar.viewAllDeals": "Alle Angebote ansehen",
  "topbar.hello": "Hallo, {name}",
  "topbar.login": "Anmelden",
  "topbar.try": "Probier:",

  "footer.contact": "Kontakt",
  "footer.terms": "Nutzungsbedingungen",
  "footer.privacy": "Datenschutzerklärung",
  "footer.pricing": "Preise",
  "footer.refunds": "Rückerstattungsrichtlinie",

  "home.todaysBest": "Die besten Angebote heute",
  "home.upToOff": "Bis zu {n}% Rabatt",
  "home.explore": "Angebote entdecken",
  "home.browseCategories": "Kategorien ansehen",
  "home.eduHeroA": "Lernen für",
  "home.eduHeroB": "weniger.",
  "home.eduHeroSub": "Finde Nachhilfe, Kurse und Unterricht in deiner Nähe — zu Preisen, die sich rechnen.",
  "home.liveDeals": "{n} aktive Angebote",
  "home.categoriesCount": "{n} Kategorien",
  "home.shopByCategory": "Nach Kategorie stöbern",
  "home.viewAll": "Alle ansehen",
  "home.featuredDeals": "⭐ Hervorgehobene Angebote",
  "home.featuredNearYou": "⭐ Hervorgehoben",
  "home.featuredIn": "⭐ Hervorgehoben in {place}",
  "home.topDeals": "Top-Angebote",
  "home.topDealsNear": "Top-Angebote in {place}",
  "home.topDealsNearYou": "Top-Angebote in deiner Nähe",
  "home.locPromptTitle": "Angebote direkt um dich herum",
  "home.locPromptDesc": "Teile deinen Standort und wir setzen die nächstgelegenen Angebote — mit Entfernungen — an den Anfang deiner Seite.",
  "home.shareLocation": "Standort teilen",
  "home.locating": "Wird lokalisiert…",

  "tourist.visitingTitle": "Zu Besuch in der Gegend?",
  "tourist.visitingDesc": "Aktiviere den Touristenmodus für die besten Angebote in der Nähe, in deiner Währung und mit Route auf einen Tipp.",
  "tourist.imVisiting": "Ich bin zu Besuch",

  "rail.yourLocation": "Dein Standort",
  "rail.change": "Ändern",
  "rail.featuredDeal": "Hervorgehobenes Angebot",
  "rail.viewDeal": "Angebot ansehen",
  "rail.nearExpiry": "Läuft bald ab",
  "rail.lastChance": "(Letzte Chance!)",
  "rail.viewAll": "Alle ansehen",
  "rail.noNearExpiry": "Derzeit läuft nichts bald ab.",
  "rail.getAlerts": "Angebots-Alarm aktivieren",
  "rail.getAlertsDesc": "Erfahre als Erster von neuen Angeboten und Blitzaktionen!",
  "rail.enableAlerts": "Alarme aktivieren",

  "lang.label": "Sprache",

  "cat.All": "Alle",
  "cat.Food": "Essen",
  "cat.Drinks": "Getränke",
  "cat.Health": "Gesundheit",
  "cat.Events": "Events",
  "cat.Lodging": "Unterkunft",
  "cat.Services": "Dienstleistungen",
  "cat.Pets": "Haustiere",
  "cat.Beauty": "Beauty",
  "cat.Tech": "Technik",
  "cat.Near Expiry": "Läuft bald ab",
  "cat.Upcoming": "Demnächst",
  "cat.Automotive": "Auto",
  "cat.Fitness": "Fitness",
  "cat.Clothing": "Kleidung",
  "cat.Plants": "Pflanzen",
  "cat.Education": "Bildung",
  "cat.Farm & Livestock": "Landwirtschaft & Vieh",
  "cat.Other": "Sonstiges",
  "cat.More": "Mehr",
  "time.expired": "Abgelaufen",
  "time.dLeft": "{d} T {h} Std übrig",
  "time.hLeft": "{h} Std {m} Min übrig",
  "time.mLeft": "{m} Min {s} Sek übrig",
  "card.save": "Spare {amount}",
  "card.review": "{n} Bewertung",
  "card.reviews": "{n} Bewertungen",
  "map.dealsHere": "{n} Angebote hier",
  "map.dealsAtSpot": "{n} Angebote an diesem Ort",
  "map.businessesHere": "{n} Geschäfte",
  "map.endsSoon": "endet bald",
  "map.viewDeal": "Angebot ansehen",
  "map.directions": "Route",
  "map.branchOf": "1 von {n} Standorten",
  "map.approx": "ca. {amount}",
  "map.subtitleGps": "Angebote rund um {place} — suche oben einen anderen Ort, um die Karte zu verschieben.",
  "map.subtitle": "Teile deinen Standort, um sofort Angebote in deiner Nähe zu sehen, oder suche oben eine Stadt bzw. wähle ein Land.",
  "map.yourLocation": "deinem Standort",
  "map.jumpTo": "Springe zu:",
  "map.autoDetected": "Angebote in {country} — nicht richtig?",
  "map.change": "Ändern",
  "map.maybeLaterBrowse": "Vielleicht später — {place} durchsuchen",
  "map.allDeals": "alle Angebote",
  "map.endingSoon": "Endet bald",
  "map.inView": "Im Bild",
  "map.all": "Alle",
  "map.inViewCount": "{n} von {m} im Bild",
  "map.nearbyCount": "{n} von {m} in der Nähe",
  "map.dealCount": "{n} Angebote",
  "map.dealCountNearby": "{n} Angebote in der Nähe",
  "map.fitAll": "Alle Angebote einpassen",
  "map.geoTitle": "Angebote in deiner Nähe sehen",
  "map.geoDesc": "Teile deinen Standort und wir zeigen dir sofort die besten Angebote um dich herum auf der Karte.",
  "map.emptyFilter": "Hier passt kein Angebot zu diesem Filter.",
  "map.emptyGps": "Noch keine Angebote in der Nähe dieses Ortes — probiere einen anderen Ort oder stöbere nach Land.",
  "map.emptyCountry": "Noch keine Angebote in {country}.",
  "map.emptyInView": "Keine Angebote in diesem Kartenausschnitt.",
  "map.zoomOut": "Herauszoomen, um alle {n} zu sehen",
  "map.myLocation": "Dein Standort",
  "map.expandMap": "Karte vergrößern",
  "map.showList": "Angebote zeigen",
  "map.openNow": "Jetzt offen",
  "map.openBadge": "Jetzt offen",
  "map.closedBadge": "Gerade geschlossen",
  "map.heatmap": "Rabatt-Heatmap",
  "map.heatLegend": "Größte Rabatte in diesem Gebiet",
  "map.shareView": "Diese Ansicht teilen",
  "map.shareTitle": "Angebote auf LytePress",
  "map.linkCopied": "Link kopiert — teile ihn überall",
  "map.sharedView": "Geteilte Kartenansicht wird angezeigt",
  "map.world": "Welt",
  "map.shopsHere": "{n} Geschäfte",
  "map.sharedAddress": "{n} Geschäfte an dieser Adresse",
  "spot.eyebrow": "Alle Angebote an dieser Adresse",
  "spot.fallbackTitle": "Diese Adresse",
  "spot.dealCount": "{n} Angebote",
  "spot.visitShop": "Zum Geschäft",
  "spot.seeAll": "Alle ansehen",
  "spot.backToMap": "Zurück zu LyteMap",
  "spot.gone": "Derzeit keine aktiven Angebote an dieser Adresse.",
  "spot.share": "Angebote teilen",
  "spot.shareCopied": "Kopiert — überall einfügen",
  "spot.shareHead": "{name} — {shops} Geschäfte, {deals} Angebote gerade auf LytePress:",
  "spot.shareMore": "…und {n} weitere",
  "map.noDealsRegion": "Noch keine Angebote in dieser Region.",
  "invite.cta": "Geschäft einladen",
  "invite.title": "Lade ein Geschäft zu LytePress ein",
  "invite.subtitle": "Kennst du einen Laden mit guten Angeboten? Sag es uns und wir laden ihn ein.",
  "invite.namePh": "Name des Geschäfts",
  "invite.cityPh": "Stadt oder Ort",
  "invite.countryPh": "Land",
  "invite.emailPh": "E-Mail (optional)",
  "invite.notePh": "Warum sollten Käufer davon wissen? (optional)",
  "invite.submit": "Einladung senden",
  "invite.privacy": "Wir nutzen diese Angaben nur für die Einladung. Es wird kein Konto erstellt.",
  "invite.sentEmail": "Einladung per E-Mail gesendet",
  "invite.logged": "Danke — notiert!",
  "invite.nudge": "Eine persönliche Nachricht wirkt am besten. Schick ihnen das:",
  "invite.shareMsg": "Hallo {name}! Stell deine Angebote auf LytePress, damit Käufer in der Nähe dich finden — der Start ist kostenlos: {url}",
  "invite.whatsapp": "Per WhatsApp senden",
  "invite.copy": "Nachricht kopieren",
  "invite.failed": "Einladung konnte nicht gesendet werden. Bitte erneut versuchen.",
  "map.citiesIn": "Städte in {country}:",
  "map.allOf": "Ganz {country}",
  "map.moreCountries": "+{n} weitere Länder",
  "map.fewerCountries": "Weniger anzeigen",
  "map.countriesIn": "Länder in {region}:",
  "reg.Caribbean": "Karibik",
  "reg.North America": "Nordamerika",
  "reg.Central America": "Mittelamerika",
  "reg.South America": "Südamerika",
  "reg.Europe": "Europa",
  "reg.Middle East": "Naher Osten",
  "reg.Africa": "Afrika",
  "reg.Asia": "Asien",
  "reg.Oceania": "Ozeanien",
  "reg.Other": "Andere",
  "pd.postTitle": "Angebot einstellen",
  "pd.editTitle": "Angebot bearbeiten",
  "pd.dealTitle": "Titel des Angebots",
  "pd.dealTitlePh": "z. B. 2 große Pizzen zum Preis von 1",
  "pd.photos": "Fotos des Angebots",
  "pd.photosHint": "(bis zu 6 - Kunden können durchwischen)",
  "pd.cover": "Titelbild",
  "pd.category": "Kategorie",
  "pd.currency": "Währung",
  "pd.redeemHow": "Wie wird dieses Angebot eingelöst?",
  "pd.inPerson": "Vor Ort",
  "pd.onlineOnly": "Nur online",
  "pd.onlineNote": "Kein Kartenpin nötig - Kunden weltweit sehen dieses Angebot",
  "pd.promoLabel": "Promo-Code für die Kasse",
  "pd.promoHint": "Bleibt verborgen, bis ein Kunde das Angebot sichert, und wird dann mit Kopier-Button gezeigt. Prüfe, dass er auf deiner Website funktioniert.",
  "pd.whichLocations": "Für welche deiner Standorte gilt dieses Angebot?",
  "pd.pinLabel": "Standort(e) des Angebots auf der Karte setzen",
  "pd.description": "Beschreibung",
  "pd.descriptionPh": "Beschreibe das Angebot...",
  "pd.dealType": "Angebotsart",
  "pd.percentOff": "Prozent Rabatt (%)",
  "pd.setPrice": "Festpreis",
  "pd.originalPrice": "Originalpreis ({sym})",
  "pd.dealPrice": "Angebotspreis ({sym})",
  "pd.discountPct": "Rabatt (%)",
  "pd.terms": "Bedingungen",
  "pd.endsOn": "Endet am",
  "pd.lastChance": "Letzte Chance",
  "pd.lastChanceNote": "läuft automatisch - dein Angebot landet dort von selbst, sobald weniger als 48 Stunden übrig sind.",
  "pd.shortDated": "Kurz datierte Ware",
  "pd.bestBefore": "Mindestens haltbar bis (optional)",
  "pd.feature": "Dieses Angebot hervorheben",
  "pd.timezone": "Zeitzone",
  "pd.publishAt": "Veröffentlichen am",
  "pd.publishHint": "Leer lassen, um sofort live zu gehen.",
  "pd.publish": "Angebot veröffentlichen",
  "pd.saveChanges": "Änderungen speichern",
  "pd.promoNeeded": "Promo-Code fehlt",
  "pd.promoNeededMsg": "Online-Angebote werden mit einem Promo-Code eingelöst - füge den Code hinzu, den Kunden verwenden sollen.",
  "pd.addDiscount": "Rabatt angeben",
  "pd.addDiscountMsg": "Gib an, wie viel Prozent Rabatt dieses Angebot hat (1-100).",
  "pd.subtitle": "Teile eine Aktion oder ein bald ablaufendes Angebot mit deiner Nachbarschaft.",
  "pd.upload": "Tippen, um Fotos hochzuladen oder aufzunehmen",
  "pd.uploadHint": "JPG, PNG oder WEBP, je bis zu 8 MB",
  "pd.branchHint": "Ankreuzen, um einen gespeicherten Standort einzubeziehen. Du kannst unten auch einen eigenen Pin setzen.",
  "picker.searchPh": "Adresse oder Ort suchen...",
  "picker.find": "Suchen",
  "picker.gps": "Mein GPS nutzen",
  "picker.hint": "Suche, nutze GPS oder tippe auf die Karte, um einen Pin zu setzen. Zieh den Pin, um die Stelle genau zu treffen.",
  "picker.namedPre": "Wir haben diesen Pin benannt:",
  "picker.editName": "Nicht richtig? Tippen, um den Namen zu ändern, den Kunden sehen",
  "pd.editSubtitle": "Passe Preis, Daten oder Details an und veröffentliche dein aktualisiertes Angebot.",
  "pd.uploading": "Wird geladen...",
  "pd.pinHint": "- setze einen Pin für jeden Standort, an dem dieses Angebot gilt. Die Standorte kommen aus deinem Geschäftsprofil (ein Angebot kann sie unten überschreiben).",
  "pd.codeReq": "Einlöse-Code im Laden verlangen",
  "pd.codeReqHint": "Kunden erhalten einen einmaligen Code samt QR, den sie an der Kasse zeigen. Du bestätigst ihn in Mein Konto - so siehst du genau, wie viele Kunden LytePress dir gebracht hat.",
  "pd.schedule": "Veröffentlichung planen",
  "pd.scheduleHint": "Automatisch zu einer genauen Zeit in der gewählten Zeitzone veröffentlichen. Aus lassen, um sofort zu veröffentlichen. Das Ende richtet sich nach dem Datum Endet am oben.",
  "pd.branchFooter": "Optional - wenn du das überspringst, setzen wir das Angebot an die registrierte Adresse deines Geschäfts ({place}). Deine Öffnungszeiten verwaltest du in",
  "pd.beating": "Du schlägst {rival}",
  "pd.beatingMsg": "Deren '{title}' hat {rivalDiscount}% Rabatt - wir haben ein stärkeres Angebot mit {discount}% vorbereitet. Anpassen, veröffentlichen und den Kunden gewinnen.",
  "pd.termsDefault": "Gültig solange der Vorrat reicht. Nicht mit anderen Angeboten kombinierbar.",
  "common.percentOff": "{n}% Rabatt",
  "common.tryAgain": "Bitte versuche es erneut.",

  "browse.title": "Angebote entdecken",
  "browse.nearYou": "Angebote in deiner Nähe",
  "browse.nearPlace": "Angebote in der Nähe von {place}",
  "browse.sortedFrom": "Nach Entfernung von {place} sortiert.",
  "browse.bestLocal": "Die besten lokalen Ersparnisse in {place}.",
  "browse.worldwide": "Großartige Angebote aus der ganzen Welt.",
  "browse.radius": "Entfernungsradius",
  "browse.openNow": "Jetzt geöffnet",
  "browse.online": "Online",
  "browse.shortDated": "Kurz datiert",
  "browse.clearSearch": "Suche löschen",
  "browse.aiNoMatch": "Keine Angebote passen zu dieser Suche. Formuliere es anders — z. B. „Restaurant-Angebote unter 20 $“ oder „Elektronik in meiner Nähe“.",
  "browse.aiUnavailable": "Die KI-Suche ist gerade nicht verfügbar — hier sind deine normalen Ergebnisse.",
  "browse.searchFilters": "Filter aus deiner Suche:",
  "browse.noDeals": "Hier gibt es noch keine Angebote",
  "browse.noMatch": "Nichts passt zu “{q}”. Probiere andere Wörter oder eine andere Kategorie.",
  "browse.closestMatches": "Keine genaue Übereinstimmung für “{q}” — das sind die nächstbesten Angebote.",
  "browse.didYouMean": "Stattdessen “{q}” suchen",
  "trending.label": "Gerade beliebt in deiner Nähe",
  "saved.cta": "Suche speichern",
  "saved.saved": "Suche gespeichert",
  "saved.section": "Gespeicherte Suchen ({n})",
  "saved.done": "“{q}” gespeichert",
  "saved.doneBody": "Wir melden uns, sobald ein passendes Angebot erscheint.",
  "saved.removed": "“{q}” entfernt",
  "saved.signIn": "Melde dich an, um Suchen zu speichern",
  "browse.browseCats": "Kategorien ansehen",
  "browse.emptyOpenNow": "Kein gerade geöffnetes Geschäft hat Angebote. Schalte „Jetzt geöffnet“ aus.",
  "browse.emptyShortDated": "Derzeit keine kurz datierte Ware — schau später wieder, sie erscheint, wenn Läden Ware kurz vor dem Datum reduzieren.",
  "browse.emptyOnline": "Noch keine reinen Online-Angebote — schalte den Online-Filter aus, um Angebote in deiner Nähe zu sehen.",
  "browse.emptyRadius": "Keine Angebote in {radius} Umgebung. Erweitere den Radius.",
  "browse.emptyRadiusPlace": "Keine Angebote in {radius} Umkreis von {place}. Erweitere den Radius.",
  "browse.emptyDefault": "Keine Angebote passen zu deinen Filtern. Entferne einen Filter oder probiere eine andere Kategorie.",
  "browse.firstBusiness": "Sei das erste Geschäft in {place}",
  "browse.firstBusinessMsg": "Hier hat noch niemand etwas eingestellt — das erste Angebot bekommt jeden Kunden, der ankommt, und dein Geschäft steht allein oben auf der Karte.",
  "browse.postFirst": "Das erste Angebot einstellen",
  "browse.yourArea": "deiner Gegend",

  "card.lastChance": "Letzte Chance",
  "card.shortDated": "Kurz datiert",
  "card.online": "Online-Angebot",
  "card.directions": "Route anzeigen",
  "card.favourite": "Zu Favoriten hinzufügen",
  "card.inYourCurrency": "in deiner Währung",
  "card.locations": "{n} Standorte",

  "fav.title": "Favoriten",
  "fav.subtitle": "Angebote, die du für später gespeichert hast.",
  "fav.emptyTitle": "Noch keine Favoriten",
  "fav.emptyMsg": "Tippe bei einem Angebot auf das Herz, um es hier zu speichern.",
  "fav.browse": "Angebote entdecken",

  "cats.heading": "Wonach suchst du?",
  "cats.allDeals": "Alle Angebote",
  "cats.endingSoon": "Endet bald",

  "mydeals.guestTitle": "Deine gesicherten Angebote leben hier",
  "mydeals.guestMsg": "Melde dich kostenlos an und jedes gesicherte Angebot — Codes, QR-Pässe und Aktionen — wird hier auf allen Geräten gespeichert, mit Erinnerung vor dem Ende.",
  "mydeals.createAccount": "Kostenloses Konto erstellen",
  "mydeals.businessTitle": "Meine Angebote ist für Kunden",
  "mydeals.businessMsg": "Verwalte deine eingestellten Angebote in deinem Dashboard.",
  "mydeals.goDashboard": "Zum Dashboard",
  "mydeals.title": "Meine Angebote",
  "mydeals.subtitle": "Alle gesicherten Angebote — zeige sie im Geschäft vor, um sie einzulösen.",
  "mydeals.emptyTitle": "Noch keine Angebote gesichert",
  "mydeals.emptyMsg": "Tippe bei einem Angebot auf \"Angebot sichern\" und es erscheint hier mit Code, Countdown und Route zum Laden.",
  "mydeals.ready": "Zum Einlösen bereit",
  "mydeals.nothingWaiting": "Nichts offen —",
  "mydeals.grabNew": "sichere ein neues Angebot",
  "mydeals.redeemedOn": "eingelöst am {date}",
  "mydeals.youSavedAmount": "du hast {amount} gespart",
  "mydeals.youSavedTotal": "Du hast {amount} gespart",
  "mydeals.redeemed": "Eingelöst",
  "mydeals.ended": "Beendet",
  "mydeals.dealEnded": "Dieses Angebot ist beendet",
  "mydeals.toRedeem": "{time} zum Einlösen",
  "mydeals.noExpiry": "Kein Ablaufdatum — jederzeit einlösbar",
  "mydeals.showAtCheckout": "An der Kasse zeigen",
  "mydeals.useOnlineCode": "Nutze deinen Code im Online-Shop",
  "mydeals.showAtBusiness": "Zeige dieses Angebot bei {business}",
  "mydeals.shortDated": "Kurz datiert",
  "mydeals.useBy": "verbrauchen bis {date}",
  "mydeals.copy": "Kopieren",
  "mydeals.codeCopied": "Code kopiert",
  "mydeals.pasteAt": "Füge {code} an der Kasse ein.",
  "mydeals.yourCode": "Hier ist dein Code",
  "mydeals.undone": "Sicherung zurückgenommen",
  "mydeals.undoneMsg": "„{title}“ wurde aus Meine Angebote entfernt.",
  "mydeals.undoFailed": "Rücknahme fehlgeschlagen",

  "nearexp.subtitle": "Schnell zugreifen, bevor sie weg sind — viel sparen und Verschwendung vermeiden.",
  "nearexp.grab": "Angebot sichern",
  "nearexp.emptyTitle": "Gerade läuft nichts ab",
  "nearexp.emptyMsg": "Momentan gibt es keine Last-Chance-Angebote. Schau bald wieder vorbei — sie erscheinen, wenn Angebote ihrem Ende nahe kommen.",
  "nearexp.browseAll": "Alle Angebote ansehen",

  "deal.notFound": "Angebot nicht gefunden.",
  "deal.back": "Zurück zu den Angeboten",
  "deal.featured": "HERVORGEHOBEN",
  "deal.zoom": "Vollbild anzeigen",
  "deal.zoomHint": "Zum Zoomen zwei Finger oder Doppeltippen",
  "deal.zoomReset": "Zum Zurücksetzen doppeltippen",
  "deal.translate": "Übersetzen",
  "deal.translated": "Übersetzt",
  "deal.translateFail": "Übersetzung nicht verfügbar",
  "deal.inYourCurrency": "in deiner Währung",
  "deal.shortDatedTitle": "Kurz datierte Ware",
  "deal.shortDatedUseBy": "verbrauchen bis {date}",
  "deal.shortDatedNote": "Völlig einwandfrei, nur im Preis gesenkt, damit sie genutzt statt weggeworfen wird. Prüfe vor dem Kauf, ob das Datum für dich passt.",
  "deal.onlineTitle": "Online-Angebot",
  "deal.onlineMsg": "Kein Ladenbesuch nötig — sichere das Angebot, um deinen Promo-Code zu sehen, und nutze ihn im Online-Shop von {business}.",
  "deal.onlineWorldwide": "Weltweit für alle Kunden verfügbar.",
  "deal.onlineBadge": "Online-Angebot · überall einlösbar",
  "deal.grab": "Angebot sichern",
  "deal.getCode": "Meinen Einlöse-Code holen",
  "deal.getPromo": "Meinen Promo-Code holen",
  "deal.signInGrab": "Kostenlos anmelden & sichern",
  "deal.grabbed": "Angebot gesichert!",
  "deal.promoUse": "Nutze diesen Promo-Code im Online-Shop von {business}:",
  "deal.copyCode": "Code kopieren",
  "deal.savedInPre": "Gespeichert in",
  "deal.savedUntilExpiry": "bis es abläuft.",
  "deal.visitToRedeem": "Besuche {business} in {location}, um dieses Angebot vor dem Ende einzulösen.",
  "deal.loginHint": "Kostenloses Kundenkonto · dauert 10 Sekunden · wir bringen dich direkt zurück",
  "deal.signInToGrab": "Anmelden, um dieses Angebot zu sichern",
  "deal.signInToGrabMsg": "Erstelle ein kostenloses Kundenkonto — wir bringen dich direkt zu diesem Angebot zurück.",
  "deal.couldNotGrab": "Angebot konnte nicht gesichert werden",
  "deal.codeCopied": "Code kopiert",
  "deal.pasteAt": "Füge {code} an der Kasse ein.",
  "deal.grabUndone": "Sicherung zurückgenommen",
  "deal.grabUndoneMsg": "Kein Problem — das Angebot ist noch da, falls du es dir anders überlegst.",
  "deal.mapUnavailable": "Karte nicht verfügbar",
  "deal.location": "Standort",
  "deal.availableAt": "An {n} Standorten verfügbar",
  "deal.directions": "Route anzeigen",
  "deal.terms": "Bedingungen",
  "deal.staffCode": "Das Personal bei {business} gibt diesen Code ein, um deinen Rabatt anzuwenden. Einmalig nutzbar — du findest ihn wieder in",
  "deal.myDeals": "Meine Angebote",
  "deal.views": "{n} Aufrufe",

  "auth.verify": "Bestätigen",
  "auth.login": "Anmelden",
  "auth.welcomeBack": "Willkommen zurück bei LytePress.",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.forgot": "Passwort vergessen?",
  "auth.newShopper": "Neuer Kunde?",
  "auth.createFree": "Kostenloses Konto erstellen",
  "auth.areBusiness": "Bist du ein Geschäft?",
  "auth.registerBusiness": "Geschäft registrieren",
  "auth.welcomeBackToast": "Willkommen zurück!",
  "auth.signedInAs": "Angemeldet als {name}",
  "auth.loginFailed": "Anmeldung fehlgeschlagen",
  "auth.invalidCreds": "Ungültige Zugangsdaten",
  "auth.mfaTitle": "Zwei-Faktor-Bestätigung",
  "auth.mfaMsg": "Gib den 6-stelligen Code aus deiner Authenticator-App ein oder nutze einen Wiederherstellungscode.",
  "auth.mfaPlaceholder": "123456 oder Wiederherstellungscode",
  "auth.trustDevice": "Diesem Gerät 30 Tage vertrauen",
  "auth.skip2fa": "(nächstes Mal ohne 2FA)",
  "auth.signupTitle": "Erstelle dein kostenloses Konto",
  "auth.signupMsg": "Folge deinen Lieblingsgeschäften und werde benachrichtigt, sobald sie ein Angebot einstellen.",
  "auth.yourName": "Dein Name",
  "auth.passwordMin": "Passwort (min. 6 Zeichen)",
  "auth.agreeTo": "Mit dem Erstellen eines Kontos akzeptierst du unsere",
  "auth.and": "und die",
  "auth.haveAccount": "Hast du schon ein Konto?",
  "auth.logIn": "Anmelden",
  "auth.signupFailed": "Registrierung fehlgeschlagen",
  "auth.welcomeToLyte": "Willkommen bei LytePress!",
  "qa.fixTitle": "Das korrigieren wir zuerst",
  "qa.uploadBlocked": "Foto nicht akzeptiert",
  "qa.pending": "Zur Prüfung gesendet",
  "qa.pendingMsg": "Dein Angebot geht online, sobald unser Team es freigibt.",
  "qa.watchNotice": "Deine Angebote werden vor der Veröffentlichung geprüft. Poste wie gewohnt — meist geben wir innerhalb weniger Stunden frei.",
  "qa.title_short": "Gib dem Angebot einen echten Titel (mindestens 6 Zeichen), damit Käufer es verstehen.",
  "qa.title_long": "Dieser Titel ist zu lang — bleib unter 90 Zeichen.",
  "qa.title_caps": "Bitte schreibe den Titel nicht in GROSSBUCHSTABEN — das wirkt wie Spam.",
  "qa.title_emoji": "Zu viele Emojis im Titel — maximal zwei.",
  "qa.desc_short": "Füge eine kurze Beschreibung hinzu (mindestens 20 Zeichen), was Käufer bekommen.",
  "qa.banned": "Diese Formulierung ist auf LytePress nicht erlaubt. Bitte entferne verbotene oder nicht jugendfreie Inhalte.",
  "qa.links": "Links und Social-Handles sind in der Beschreibung nicht erlaubt — Käufer kontaktieren dich über dein Profil, wo deine Daten stehen.",
  "qa.phone": "Bitte keine Telefonnummern in der Beschreibung — trage sie in dein Geschäftsprofil ein.",
  "qa.price_invalid": "Preis und vorheriger Preis müssen Zahlen sein.",
  "qa.disc_high": "Ein Rabatt über {max}% ist unglaubwürdig — Käufer melden solche Angebote. Bitte korrigieren.",
  "qa.was_low": "Der vorherige Preis muss höher sein als der Angebotspreis.",
  "qa.disc_mismatch": "Dein Rabatt passt nicht zu den Preisen — {price} statt {was} sind {computed}% Rabatt, nicht {discount}%.",
  "qa.dup_title": "Du hast schon ein aktives Angebot mit genau diesem Titel — bearbeite es oder wähle einen anderen Titel.",
  "qa.img_small": "Dieses Foto hat nur {w}×{h}px und würde unscharf aussehen. Bitte mindestens {minW}×{minH}px.",
  "qa.img_blank": "Dieses Bild wirkt leer oder einfarbig. Bitte lade ein echtes Foto des Angebots hoch.",
  "qa.img_blurry": "Dieses Foto wirkt unscharf. Bitte lade ein schärferes Foto hoch.",
  "qa.img_unreadable": "Wir konnten dieses Bild nicht lesen. Bitte lade ein JPG, PNG oder WebP hoch.",
  "qa.img_duplicate": "Dieses Foto nutzt schon ein anderes Geschäft auf LytePress. Bitte lade dein eigenes Foto hoch.",
  "qa.ai_blocked": "Unsere Inhaltsprüfung hat dieses Angebot blockiert (nicht jugendfreie oder drastische Inhalte). Falls das ein Fehler ist, schreib an support@lytepress.com.",
  "qa.planLimit": "Du hast das Angebotslimit deines Tarifs erreicht",
  "qa.seePlans": "Tarife ansehen",
  "qa.coachGood": "Sieht super aus",
  "qa.coachChecking": "Foto wird geprüft…",
  "qa.coachSmall": "Zu klein ({w}×{h}px) — nötig sind {minW}×{minH}px",
  "qa.coachBlurry": "Wirkt unscharf — versuche ein schärferes Foto",
  "qa.coachBlank": "Wirkt leer — lade ein echtes Foto des Angebots hoch",
  "invite.signInTitle": "Melde dich an, um ein Geschäft vorzuschlagen",
  "invite.signInMsg": "Ein kostenloses Konto dauert Sekunden und hält Einladungen echt.",
  "prc.badge": "Tarife für Geschäfte",
  "prc.h1": "Wachse schneller mit LytePress",
  "prc.sub": "Poste mehr Angebote, werde zuerst gesehen und sieh, wie du gegen den Laden nebenan abschneidest.",
  "prc.chipAnalytics": "Volle Statistiken",
  "prc.yourPlan": "Dein Tarif: {plan}",
  "prc.dealsUsed": "{used} von {limit} aktiven Angeboten genutzt",
  "prc.unlimited": "unbegrenzt",
  "prc.monthly": "Monatlich",
  "prc.yearly": "Jährlich",
  "prc.save17": "17 % sparen",
  "prc.free": "Kostenlos",
  "prc.freeSub": "Zum Starten",
  "prc.f3": "Aufrufe im Blick",
  "prc.currentPlan": "Dein aktueller Tarif",
  "prc.pro": "Pro",
  "prc.perYear": "/ Jahr",
  "prc.per30": "/ 30 Tage",
  "prc.proYearNote": "Etwa {monthly}/Monat — 2 Monate gratis",
  "prc.proMonthNote": "oder {yearly}/Jahr — 17 % sparen",
  "prc.p2": "Volle Statistiken & Vergleich mit der Konkurrenz",
  "prc.p4": "Alle Follower über neue Angebote informieren",
  "prc.plus": "Elite",
  "prc.plusYearNote": "Das sind {monthly}/Monat — 2 Monate gratis",
  "prc.plusMonthNote": "Für Geschäfte mit Volumen oder mehreren Filialen",
  "prc.activeLife": "Lebenslang aktiv",
  "prc.renewsOn": "Verlängert am {date}",
  "prc.endsOn": "Endet am {date}",
  "prc.cancelRenewPro": "Verlängerung kündigen (Pro bleibt bis zum Ende)",
  "prc.cancelRenew": "Automatische Verlängerung kündigen",
  "prc.resumeRenew": "Verlängerung wieder aktivieren",
  "prc.goYearly": "Jährlich buchen — {price}",
  "prc.goMonthly": "Monatlich buchen — {price}",
  "prc.guarantee": "14 Tage Geld zurück —",
  "prc.guaranteeLink": "ohne Wenn und Aber",
  "prc.boostTitle": "Kurzfristig mehr Sichtbarkeit?",
  "prc.myAccount": "Mein Konto",
  "prc.boostRefundPre": "Vor Beginn der Platzierung voll erstattbar — siehe die",
  "prc.refundPolicy": "Rückerstattungsrichtlinie",
  "prc.testMode": "Testmodus — Karte 4242 4242 4242 4242, beliebiges künftiges Datum und CVC.",
  "prc.sp1": "Alle Preise in US-Dollar. Je nach Land kann beim Bezahlen Umsatzsteuer hinzukommen — den genauen Betrag siehst du vor der Zahlung.",
  "prc.sp4pre": "Unsicher? Jede Abo-Zahlung ist durch unsere",
  "prc.sp4link": "14-tägige Geld-zurück-Garantie",
  "prc.sp4post": "Käufer zahlen nie für die Nutzung von LytePress.",
  "prc.bizOnly": "Nur Geschäftskonten",
  "prc.bizOnlyMsg": "Bezahlte Tarife sind für Geschäfte, die Angebote posten.",
  "prc.checkoutFail": "Bezahlvorgang konnte nicht gestartet werden",
  "prc.tryAgain": "Bitte versuche es erneut.",
  "prc.renewOff": "Automatische Verlängerung aus",
  "prc.renewOn": "Automatische Verlängerung an",
  "prc.subFail": "Abo konnte nicht aktualisiert werden",
  "ck.title": "Wir verwenden Cookies",
  "ck.body": "Wir verwenden notwendige Cookies für den Betrieb von LytePress und optionale, um dein Erlebnis zu verbessern. Siehe unsere",
  "ck.privacy": "Datenschutzerklärung",
  "ck.acceptAll": "Alle akzeptieren",
  "ck.essential": "Nur notwendige",
  "ck.dismiss": "Schließen",
  "undo.label": "Rückgängig",
  "undo.done": "Wiederhergestellt",
  "undo.failed": "Konnte nicht rückgängig gemacht werden — bitte erneut versuchen",
  "follows.unfollow": "Nicht mehr folgen",
  "follow.follow": "Folgen",
  "follow.following": "Folgt",
  "follow.now": "Du folgst {name}",
  "follow.nowMsg": "Wir melden uns, sobald es ein neues Angebot gibt.",
  "follow.stopped": "Du folgst {name} nicht mehr",
  "follow.signInTitle": "Zum Folgen anmelden",
  "follow.signInMsg": "Erstelle ein kostenloses Käuferkonto für Angebots-Hinweise.",
  "acc.shopperAccount": "Käuferkonto",
  "acc.verifiedSavingsThisMonth": "Verifizierte Ersparnisse diesen Monat",
  "acc.redeemADealCode": "Lösen Sie einen Rabattcode im Geschäft ein, um verifizierte Ersparnisse zu sammeln.",
  "acc.topSaverEveryBadge": "Top-Sparer — jedes Abzeichen freigeschaltet!",
  "acc.recentRedemptions": "Kürzliche Einlösungen",
  "acc.showPricesInMy": "Preise in meiner Währung anzeigen",
  "acc.dealsShowAnApproximate": "Angebote zeigen einen ungefähren Preis in dieser Währung in der App.",
  "acc.showPricesAsIs": "Preise unverändert anzeigen",
  "acc.emailPreferences": "E-Mail-Einstellungen",
  "acc.newDealAlerts": "Neue Angebotsbenachrichtigungen",
  "acc.emailMeWhenA": "Schicken Sie mir eine E-Mail, wenn ein Unternehmen, dem ich folge, ein neues Angebot postet.",
  "acc.accountSecurityEmailsReceipts": "E-Mails zu Konto & Sicherheit (Quittungen, Passwortzurücksetzungen) werden immer gesendet.",
  "acc.myRedemptionCodes": "Meine Einlösungscodes",
  "acc.businessesYouFollow": "Unternehmen, denen Sie folgen",
  "acc.youReNotFollowing": "Sie folgen noch keinem Unternehmen. Folgen Sie einem Unternehmen, um benachrichtigt zu werden, wenn es ein Angebot postet.",
  "acc.browseBusinesses": "Unternehmen durchsuchen",
  "acc.postADeal": "Ein Angebot posten",
  "acc.redeemACustomerS": "Einen Kunden-Code einlösen",
  "acc.whenAShopperShows": "Wenn ein Käufer seinen Code oder QR an der Kasse zeigt, scannen Sie ihn oder geben Sie ihn hier ein, um den Rabatt zu bestätigen und anzuwenden.",
  "acc.pointTheCameraAt": "Richten Sie die Kamera auf den QR-Code des Käufers.",
  "acc.dealsAlsoShowAn": "Angebote zeigen auch einen ungefähren Preis in dieser Währung in der App.",
  "acc.recommendedLogo": "Empfohlen: Logo",
  "acc.noCoverPhotoYet": "Noch kein Titelbild",
  "acc.contactInfo": "Kontaktinformationen",
  "acc.showContactInfoOn": "Kontaktinformationen auf meinem öffentlichen Profil anzeigen",
  "acc.addAnotherNumber": "Eine weitere Nummer hinzufügen",
  "acc.saveContactInfo": "Kontaktinformationen speichern",
  "acc.upgradeForMore": "Upgrade für mehr",
  "acc.myDeals": "Meine Angebote",
  "acc.featureNudgeTitle": "Werde #1 in deiner Kategorie",
  "acc.featureNudgeBody": "Bring eines deiner Angebote ganz oben auf unsere Startseite für Käufer in deinem Land — nur 10 $ für 24 Stunden.",
  "acc.featureNudgeCta": "Angebot hervorheben",
  "acc.bookingsTitle": "Bevorstehende Hervorhebungs-Buchungen",
  "acc.bookingCancel": "Stornieren",
  "acc.bookingLive": "Jetzt live",
  "acc.bookingCancelled": "Buchung storniert",
  "acc.bookingRefunded": "Storniert — auf deine Karte erstattet",
  "acc.bookingCancelFailed": "Buchung konnte nicht storniert werden",
  "acc.youHavenTPosted": "Sie haben noch keine Angebote gepostet.",
  "acc.getListedTitle": "Sie sind noch nicht gelistet",
  "acc.getListedBody": "Neue Unternehmen erscheinen erst auf LytePress, sobald sie ein aktives Angebot veröffentlichen. Posten Sie Ihr erstes Angebot, um gelistet zu werden und Kunden in Ihrer Nähe zu erreichen.",
  "acc.postYourFirstDeal": "Posten Sie Ihr erstes Angebot",
  "acc.pendingReview": "Wartet auf Überprüfung",
  "acc.undoGrabReleaseThis": "Rückgängig machen — diesen Code freigeben",
  "acc.enterCodeEG": "Code eingeben z.B. 7K9M2Q",
  "acc.labelEGPort": "Bezeichnung (z.B. Filiale Port of Spain)",
  "acc.removeNumber": "Nummer entfernen",
  "acc.shareOfViewersWho": "Anteil der Zuschauer, die dieses Angebot beansprucht haben",
  "acc.duplicateThisDealAnd": "Dieses Angebot duplizieren und vor dem Relaunch bearbeiten",
  "acc.couldNotUpdatePreferences": "Konnte die Einstellungen nicht aktualisieren",
  "acc.grabUndone": "Greifen rückgängig gemacht",
  "acc.couldnTUndo": "Konnte nicht rückgängig gemacht werden",
  "acc.codeRedeemed": "Code eingelöst ✓",
  "acc.couldnTRedeem": "Konnte nicht eingelöst werden",
  "acc.cameraUnavailable": "Kamera nicht verfügbar",
  "acc.allowCameraAccessOr": "Kamerazugriff erlauben oder den Code stattdessen eingeben.",
  "acc.saveMoreWasteLess": "Mehr sparen. Weniger verschwenden. — Weiter Angebote schnappen!",
  "acc.contactInfoSaved": "Kontaktinformationen gespeichert",
  "acc.couldNotSave": "Konnte nicht speichern",
  "acc.pleaseTryAgain": "Bitte versuchen Sie es erneut.",
  "acc.uploadFailed": "Upload fehlgeschlagen",
  "acc.dealRemoved": "Deal entfernt",
  "acc.couldNotRemove": "Konnte nicht entfernen",
  "acc.boostedForDays": "7 Tage hervorgehoben",
  "acc.couldNotStartCheckout": "Konnte den Checkout nicht starten",
  "acc.copyCreated": "Kopie erstellt",
  "acc.couldNotDuplicate": "Konnte nicht duplizieren",
  "tfa.twoFactorAuthentication": "Zwei-Faktor-Authentifizierung",
  "tfa.addAnExtraLayer": "Füge eine zusätzliche Sicherheitsebene mit einer Authenticator-App (Google Authenticator, Authy, 1Password) hinzu.",
  "tfa.disableFa": "2FA deaktivieren",
  "tfa.trustedDevices": "Vertrauenswürdige Geräte",
  "tfa.revokeAllRequireFa": "Alle widerrufen / 2FA überall erforderlich machen",
  "tfa.noTrustedDevicesWhen": "Keine vertrauenswürdigen Geräte. Wenn du dich anmeldest, aktiviere „Dieses Gerät 30 Tage lang vertrauen“, um die 2FA-Abfrage hier zu überspringen.",
  "tfa.eachCodeWorksOnce": "Jeder Code funktioniert einmal, wenn du deinen Authenticator verlierst. Bewahre sie an einem sicheren Ort auf — sie werden nicht erneut angezeigt.",
  "tfa.copyAllCodes": "Alle Codes kopieren",
  "tfa.iVeSavedThem": "Ich habe sie gespeichert",
  "tfa.confirmYourPasswordAnd": "Bestätige dein Passwort und einen aktuellen Authenticator-Code, um 2FA auszuschalten.",
  "tfa.yourPassword": "Dein Passwort",
  "tfa.digitCode": "6-stelliger Code",
  "tfa.deviceRevoked": "Gerät widerrufen",
  "tfa.thatDeviceWillNeed": "Dieses Gerät benötigt beim nächsten Mal einen 2FA-Code.",
  "tfa.couldNotRevokeDevice": "Konnte Gerät nicht widerrufen",
  "tfa.allTrustedDevicesRemoved": "Alle vertrauenswürdigen Geräte entfernt",
  "tfa.faWillBeRequired": "2FA wird auf jedem Gerät erforderlich sein.",
  "tfa.couldNotRevokeDevices": "Konnte Geräte nicht widerrufen",
  "tfa.couldNotStartFa": "Konnte die 2FA-Einrichtung nicht starten",
  "tfa.pleaseTryAgain": "Bitte versuche es erneut.",
  "tfa.twoFactorAuthenticationEnabled": "Zwei-Faktor-Authentifizierung aktiviert ✓",
  "tfa.saveYourRecoveryCodes": "Speichere deine Wiederherstellungscodes an einem sicheren Ort.",
  "tfa.couldnTVerifyCode": "Konnte den Code nicht verifizieren",
  "tfa.twoFactorAuthenticationDisabled": "Zwei-Faktor-Authentifizierung deaktiviert",
  "tfa.youCanReEnable": "Du kannst es jederzeit wieder aktivieren.",
  "tfa.couldNotDisableFa": "Konnte 2FA nicht deaktivieren",
  "trips.savedTrips": "Gespeicherte Reisen",
  "trips.saveADestinationAnd": "Speichere ein Ziel und erhalte Deal-Benachrichtigungen, bevor du ankommst.",
  "trips.addTrip": "Reise hinzufügen",
  "trips.pickAPopularCity": "Wähle eine beliebte Stadt…",
  "trips.departureOptional": "Abreise (optional)",
  "trips.noTripsYetSave": "Noch keine Reisen — speichere eine, um Deal-Benachrichtigungen zu erhalten, bevor du landest.",
  "trips.orSearchAnyCity": "…oder suche nach einer Stadt, einem Hotel oder einem Wahrzeichen",
  "trips.searchPlace": "Ort suchen",
  "trips.deleteTrip": "Reise löschen",
  "trips.placeNotFound": "Ort nicht gefunden",
  "trips.tryACityHotel": "Versuche eine Stadt, ein Hotel oder ein Wahrzeichen.",
  "trips.addADestinationAnd": "Füge ein Ziel und ein Startdatum hinzu",
  "trips.tripSavedUUfe": "Reise gespeichert \\u2708\\ufe0f",
  "trips.couldnTSaveTrip": "Konnte die Reise nicht speichern",
  "hrs.openingHours": "Öffnungszeiten",
  "hrs.setOnceHereEvery": "Einmal hier einstellen — jeder Deal, den du postest, verwendet diese Zeiten, um den Käufern zu zeigen, wann du geöffnet hast.",
  "hrs.timeZone": "Zeitzone",
  "hrs.copyMondayToAll": "Montag auf alle Tage kopieren",
  "hrs.holidayVacationMode": "Urlaubsmodus",
  "hrs.showsYourBusinessAs": "Zeigt Ihr Geschäft überall als „Vorübergehend geschlossen“. Ihre Angebote bleiben sichtbar.",
  "hrs.reopenDateOptional": "Wiedereröffnungsdatum (optional)",
  "hrs.messageOptional": "Nachricht (optional)",
  "hrs.eGBackOn": "z.B. Wieder ab 5. Jan — schöne Feiertage!",
  "hrs.mondayCopiedToEvery": "Montag auf jeden Tag kopiert",
  "hrs.tweakAnyDayThat": "Ändern Sie jeden Tag, der anders ist, und speichern Sie dann.",
  "hrs.hoursSaved": "Stunden gespeichert",
  "hrs.yourOpeningHoursNow": "Ihre Öffnungszeiten gelten jetzt für alle Ihre Angebote.",
  "hrs.couldNotSave": "Konnte nicht speichern",
  "hrs.pleaseTryAgain": "Bitte versuchen Sie es erneut.",
  "br.businessLocations": "Geschäftsstandorte",
  "br.defaultCurrency": "Standardwährung",
  "br.yourDefaultCurrencyIs": "Ihre Standardwährung ist festgelegt.",
  "br.itSFixedTo": "Es ist festgelegt auf",
  "br.becauseYouAlreadyHave": "weil Sie bereits aktive Angebote haben — dies hält Ihre Preise und bisherigen Einlösungen konsistent. Kontaktieren Sie den Support, wenn Sie es wirklich ändern müssen.",
  "br.usedAsTheDefault": "Wird als Standardpreiswährung für neue Angebote verwendet. Hinweis: dies wird festgelegt, sobald Sie Ihr erstes Angebot veröffentlichen.",
  "br.weReMultinationalSet": "Wir sind multinational — legen Sie eine Währung pro Filiale fest",
  "br.pinEveryBranchLocation": "Jeden Standort, an dem Sie tätig sind, festlegen. Wenn Sie ein Angebot posten, werden diese automatisch als Standorte des Angebots verwendet — Sie können sie jedoch pro Angebot ändern.",
  "br.locationsSaved": "Standorte gespeichert",
  "br.newDealsWillDefault": "Neue Angebote werden standardmäßig auf diese Standorte und Währung eingestellt.",
  "br.couldNotSave": "Konnte nicht speichern",
  "br.pleaseTryAgain": "Bitte versuchen Sie es erneut.",
  "tb.recentSearches": "Kürzliche Suchen",
  "tb.didYouMean": "Meinten Sie",
  "tb.noQuickMatchesPress": "Keine schnellen Übereinstimmungen — drücken Sie Enter, um alles zu durchsuchen.",
  "tb.searchDeals": "Angebote suchen",
  "tb.toggleAiAssistedSearch": "KI-unterstützte Suche umschalten",
  "tb.findDealsNearMe": "Angebote in meiner Nähe finden",
  "tb.removeFromRecentSearches": "Von den letzten Suchen entfernen",
  "tb.showDealsEverywhere": "Angebote überall anzeigen",
  "tb.searchThisPlace": "Diesen Ort suchen",
  "tb.toggleTheme": "Thema umschalten",
  "tb.locationSet": "Standort festgelegt",
  "tb.placeNotFound": "Ort nicht gefunden",
  "tb.tryADifferentCity": "Versuchen Sie einen anderen Stadtnamen oder Ort.",
  "tb.showingDealsEverywhere": "Angebote überall anzeigen",
  "tb.browsingDealsFromAll": "Durchsuchen von Angeboten aus allen Ländern.",
  "tb.notSupported": "Nicht unterstützt",
  "tb.geolocationIsnTAvailable": "Geolokalisierung ist in diesem Browser nicht verfügbar.",
  "tb.locationFound": "Standort gefunden",
  "tb.locationPermissionDenied": "Standortberechtigung verweigert",
  "tb.allowLocationForThis": "Erlauben Sie den Standort für diese Seite in den Einstellungen Ihrer Browser-Adressleiste und tippen Sie dann erneut auf In meiner Nähe.",
  "tb.locationTimedOut": "Standortzeitüberschreitung",
  "tb.couldnTGetA": "Konnte nicht rechtzeitig einen Standort ermitteln. Bewegen Sie sich in den Freien oder versuchen Sie es erneut — oder wählen Sie eine Stadt oben aus.",
  "tb.locationUnavailable": "Standort nicht verfügbar",
  "tb.weCouldnTDetermine": "Wir konnten Ihre Position nicht bestimmen. Versuchen Sie es erneut oder wählen Sie ein Land/eine Stadt oben aus.",
  "an.couldNotLoadAnalytics": "Konnte Analysen nicht laden.",
  "an.performanceOfYourDeals": "Leistung Ihrer Angebote und Aktionen.",
  "an.postADeal": "Ein Angebot posten",
  "an.noDealsYetPost": "Noch keine Angebote — posten Sie Ihr erstes Angebot, um Analysen zu sehen.",
  "an.yourAverageDiscountIs": "Ihr durchschnittlicher Rabatt beträgt",
  "an.belowTheNearbyAverage": "unter dem durchschnittlichen Rabatt in der Nähe von",
  "an.forYourCategoryA": "für Ihre Kategorie. Ein etwas größerer Rabatt bringt normalerweise mehr Aufrufe und Shares.",
  "an.bestTimeToPost": "Beste Zeit zum Posten",
  "an.newFollowersLastDays": "Neue Follower (letzte 14 Tage)",
  "an.viewsOverTime": "Aufrufe über die Zeit",
  "an.lastDays": "Letzte 14 Tage",
  "an.noViewDataYet": "Noch keine Aufrufdaten — diese werden aufgebaut, während Käufer Ihre Angebote öffnen.",
  "an.yourCompetition": "Ihre Konkurrenz",
  "an.liveDeals": "Aktive Angebote",
  "an.avgDiscount": "Durchschnittlicher Rabatt",
  "an.tipClickARival": "Tipp: Klicken Sie auf einen Konkurrenten, um Ihre aktiven Angebote nebeneinander zu vergleichen.",
  "an.redemptionsByDeal": "Einlösungen nach Angebot",
  "an.bestPerformer": "Bester Performer",
  "an.redemptionsAreCustomersWho": "Einlösungen sind Kunden, die ihren LytePress-Code im Geschäft gezeigt haben — der Beweis, dass die Plattform sie zu Ihnen geschickt hat.",
  "an.redemptionsOverTime": "Einlösungen über die Zeit",
  "an.dealLeaderboard": "Angebots-Rangliste",
  "an.byRedemptionRate": "nach Einlösungsrate",
  "an.viewsByCategory": "Aufrufe nach Kategorie",
  "an.noDataYet": "Noch keine Daten.",
  "an.topPerformingDeals": "Top-Angebote",
  "an.sharesOverTime": "Shares über die Zeit",
  "an.noSharesYetThis": "Noch keine Shares — diese Zeile wächst, während Käufer Ihre Angebote mit Freunden teilen.",
  "an.mostSharedDeals": "Am häufigsten geteilte Angebote",
  "an.noSharesYetThis2": "Noch keine Shares — diese füllt sich, während Käufer den Teilen-Button verwenden, um Ihre Angebote an Freunde zu verbreiten.",
  "an.loadingComparison": "Vergleich wird geladen…",
  "an.noLiveDeals": "Keine aktiven Angebote.",
  "an.matchOrBeat": "Gleichziehen oder übertreffen",
  "an.totalViews": "Gesamtaufrufe",
  "an.totalDeals": "Gesamtangebote",
  "an.activeDeals": "Aktive Angebote",
  "an.avgDiscount2": "Durchschn. Rabatt",
  "an.totalShares": "Gesamtshares",
  "an.inStoreRedemptions": "Einlösungen im Geschäft",
  "an.nearExpiry": "Nahe dem Ablauf",
  "reg.registerYourBusiness": "Registrieren Sie Ihr Geschäft",
  "reg.startPostingDealsTo": "Beginnen Sie, Angebote für Ihre Community zu posten.",
  "reg.whereIsYourBusiness": "Wo ist Ihr Geschäft?",
  "reg.yourMainLocationYou": "Ihr Hauptstandort — Sie können nach der Anmeldung weitere Filialen in Mein Konto → Standorte hinzufügen.",
  "reg.dealCurrency": "Angebotswährung",
  "reg.byCreatingAnAccount": "Durch die Erstellung eines Kontos stimmen Sie unseren",
  "reg.termsOfUse": "Nutzungsbedingungen",
  "reg.privacyPolicy": "Datenschutzrichtlinie",
  "reg.alreadyRegistered": "Bereits registriert?",
  "reg.logIn": "Einloggen",
  "reg.yourName": "Ihr Name",
  "reg.businessName": "Geschäftsname",
  "reg.pickYourCity": "Wähle deine Stadt",
  "reg.startTypingYourCity": "Beginne, deine Stadt einzugeben und wähle sie aus der Liste aus.",
  "reg.accountCreated": "Konto erstellt!",
  "reg.registrationFailed": "Registrierung fehlgeschlagen",
  "rst.setANewPassword": "Setze ein neues Passwort",
  "rst.chooseAStrongPassword": "Wähle ein starkes Passwort, das du nicht anderswo verwendest.",
  "rst.forgotPassword": "Passwort vergessen",
  "rst.newPassword": "Neues Passwort",
  "rst.confirmNewPassword": "Neues Passwort bestätigen",
  "rst.passwordTooShort": "Passwort zu kurz",
  "rst.useAtLeastCharacters": "Verwende mindestens 8 Zeichen.",
  "rst.passwordsDonTMatch": "Passwörter stimmen nicht überein",
  "rst.passwordReset": "Passwort zurückgesetzt ✓",
  "rst.youCanNowLog": "Du kannst dich jetzt mit deinem neuen Passwort anmelden.",
  "rst.couldnTResetPassword": "Passwort konnte nicht zurückgesetzt werden",
  "fgt.checkYourEmail": "Überprüfe deine E-Mail",
  "fgt.ifThatEmailIs": "Wenn diese E-Mail registriert ist, haben wir einen Link zum Zurücksetzen deines Passworts gesendet. Er läuft in 45 Minuten ab.",
  "fgt.forgotYourPassword": "Passwort vergessen?",
  "fgt.enterYourEmailAnd": "Gib deine E-Mail-Adresse ein und wir senden dir einen Rücksetzlink.",
  "fgt.rememberedIt": "Erinnert?",
  "fgt.logIn": "Anmelden",
  "ct.contactUs": "Kontaktiere uns",
  "ct.questionsPartnershipsOrFeedback": "Fragen, Partnerschaften oder Feedback – wir würden uns freuen, von dir zu hören.",
  "ct.sendMessage": "Nachricht senden",
  "ct.yourName": "Dein Name",
  "ct.emailAddress": "E-Mail-Adresse",
  "ct.yourMessage": "Deine Nachricht",
  "ct.messageSent": "Nachricht gesendet",
  "ct.thanksForReachingOut": "Danke für deine Nachricht – wir antworten meist innerhalb eines Werktags.",
  "st.ourStory": "Unsere Geschichte",
  "st.saveMoreWasteLess": "Mehr sparen. Weniger verschwenden. Lokal unterstützen.",
  "st.moreThanADirectory": "Mehr als ein Verzeichnis. Mehr als eine Angebotswebsite.",
  "st.lookingAheadOurGoal": "Blickt man in die Zukunft, ist es unser Ziel, in den internationalen Markt zu expandieren – damit Reisende und Touristen LytePress überall auf der Welt öffnen und sofort die besten Angebote in ihrer Nähe finden können, egal wohin ihre Reise sie führt.",
  "st.thinkOfItThis": "Sieh es so – Seiten wie Expedia helfen dir, die Reise zu planen; LytePress hilft dir, zu sparen, wenn du dort bist, mit den besten lokalen Angeboten in deiner Nähe.",
  "st.whetherYouReA": "Egal, ob du ein Unternehmen bist, das neue Kunden erreichen möchte, oder ein Verbraucher, der entdecken möchte, was um dich herum passiert – LytePress ist hier, um dir zu helfen, mehr zu sparen, weniger zu verschwenden und lokal zu unterstützen.",
  "st.exploreDeals": "Angebote erkunden",
  "st.contactUs": "Kontaktiere uns",
  "st.supportLocal": "Lokal unterstützen",
  "st.wasteLess": "Weniger verschwenden",
  "st.communityFirst": "Gemeinschaft zuerst",
  "lg.lytepressOnlyEverCharges": "LytePress erhebt nur",
  "lg.onASingleDeal": "für ein einzelnes Angebot, und ein",
  "lg.shoppersNeverPayUs": "Käufer zahlen uns nie für ein Angebot. Jedes Angebot wird vom Unternehmen verkauft und eingelöst, das es veröffentlicht hat, sodass alles, was mit den Waren oder Dienstleistungen selbst zu tun hat – der im Geschäft verlangte Preis, Qualität, Verfügbarkeit, Umtausch oder Rückerstattungen – zwischen dem Käufer und diesem Unternehmen gemäß deren eigener Richtlinie und dem lokalen Verbrauchergesetz geregelt wird.",
  "lg.ifABusinessRefuses": "Wenn ein Unternehmen sich weigert, ein veröffentlichtes Angebot einzuhalten, teile uns dies über die Meldemöglichkeit beim Angebot oder über die Kontaktseite mit. Wir können das Angebot und das Unternehmen von LytePress entfernen, aber wir können keinen Kauf erstatten, für den wir keine Zahlung erhalten haben.",
  "lg.ofThePaymentAnd": "der Zahlung und wir erstatten diese Zahlung vollständig zurück. Kein Grund erforderlich, und es gilt für monatliche und jährliche Pläne.",
  "lg.cancelAndWeRefund": "kündigen und wir erstatten vollständig.",
  "lg.thePlacementHasAlready": "die Platzierung wurde bereits an Käufer ausgeliefert, daher ist sie nicht erstattbar. Du kannst das Angebot jedoch weiterhin entfernen oder bearbeiten, aber die Ausgaben bleiben verbraucht.",
  "lg.ifAPlacementFailed": "Wenn eine Platzierung aufgrund eines Fehlers unsererseits fehlgeschlagen ist – sie nie live ging oder das Angebot während des Zeitraums von uns verborgen wurde – erstatten wir es vollständig oder führen es erneut aus, je nachdem, was du bevorzugst.",
  "lg.emailUsFromThe": "Schreibe uns von der Adresse deines LytePress-Kontos oder nutze die Kontaktseite, mit deinem Firmennamen und dem Datum der Belastung. Wir antworten innerhalb von 3 Werktagen. Genehmigte Rückerstattungen gehen zurück auf die ursprüngliche Zahlungsmethode und können je nach Bank 5–10 Werktage dauern, bis sie erscheinen.",
  "lg.refundsIncludeAnyTax": "Rückerstattungen beinhalten alle Steuern, die wir auf die ursprüngliche Zahlung erhoben haben. Wir erstatten in der Währung, in der du belastet wurdest – wenn deine Bank den Betrag umgerechnet hat, kann der Betrag, der ankommt, aufgrund von Wechselkursen oder Bankgebühren, die wir nicht kontrollieren, leicht abweichen.\n\nUnsere Preise werden in US-Dollar (USD) festgelegt. An der Kasse kann unser Zahlungsanbieter den Betrag in deiner Landeswährung anzeigen und abbuchen, umgerechnet zu seinem eigenen Wechselkurs. Jede Transaktion kann außerdem Währungsumrechnungsgebühren, Bankgebühren, Gebühren des Karten­ausstellers oder andere von deiner Bank oder deinem Kartenanbieter erhobene Gebühren unterliegen. Diese kommen zum angezeigten Preis hinzu, liegen außerhalb unserer Kontrolle und gehen zu deinen Lasten.",
  "lg.pleaseTalkToUs": "Bitte sprich mit uns, bevor du einen Streit mit deiner Bank erhebst – wir können es fast immer schneller klären. Konten mit einer ungelösten Rückbuchung können bis zur Klärung pausierte kostenpflichtige Funktionen haben.",
  "lg.youCanStopUsing": "Du kannst LytePress jederzeit nutzen und deine Angebote aus Mein Konto löschen. Das Kündigen eines Kontos führt nicht automatisch zu einer Rückerstattung einer bereits getätigten Zahlung – nutze die oben genannten Regeln.",
  "lg.billingQuestionsReachUs": "Fragen zur Abrechnung? Kontaktiere uns über die Kontaktseite.",
  "lg.lytepressHelpsShoppersDiscover": "LytePress hilft Käufern, lokale und globale Angebote zu entdecken und ermöglicht es Unternehmen, Angebote zu veröffentlichen. Du musst in der Lage sein, einen verbindlichen Vertrag abzuschließen, um den Dienst zu nutzen, und du stimmst zu, ihn rechtmäßig zu nutzen.",
  "lg.youAreResponsibleFor": "Du bist verantwortlich dafür, deine Anmeldedaten und alle Zwei-Faktor-Codes sicher zu halten. Geschäftskonten sind verantwortlich für die Genauigkeit der Angebote, Preise, Filialen und Kontaktdaten, die sie veröffentlichen.",
  "lg.dealsAreOfferedBy": "Angebote werden von den Unternehmen angeboten, die sie veröffentlichen, nicht von LytePress. Verfügbarkeit, Preisgestaltung und Einlösung im Geschäft liegen in der Verantwortung dieses Unternehmens. Einlösungscodes sind nur einmal verwendbar, sofern nicht anders angegeben.",
  "lg.refundPolicy": "Rückerstattungsrichtlinie",
  "lg.donTPostUnlawful": "Veröffentliche keine rechtswidrigen, irreführenden oder verletzenden Inhalte, versuche nicht, den Dienst zu stören, oder missbrauche die Daten anderer Nutzer.",
  "lg.weMayUpdateThese": "Wir können diese Bedingungen oder den Dienst aktualisieren und Konten, die dagegen verstoßen, vorübergehend sperren. Die fortgesetzte Nutzung nach Änderungen bedeutet, dass du die aktualisierten Bedingungen akzeptierst.",
  "lg.questionsAboutTheseTerms": "Fragen zu diesen Bedingungen? Kontaktiere uns über die Kontaktseite.",
  "lg.toRunTheService": "Um den Dienst auszuführen – dir relevante Angebote in deiner Nähe zu zeigen, dir Angebotsbenachrichtigungen zu senden, die du abonnierst, Einlösungen und Zahlungen zu verarbeiten und dein Konto sicher zu halten.",
  "lg.ifYouUseNear": "Wenn du \"In meiner Nähe\" oder den Touristenmodus verwendest, nutzen wir den Standort, den du angibst (oder den Standort deines Geräts, mit Erlaubnis) nur, um nahegelegene Angebote zu finden. Du kannst stattdessen immer einen Standort manuell auswählen.",
  "lg.ipAndGeo": "Um dein Erlebnis zu verbessern, verwenden wir deine IP-Adresse, um deinen ungefähren Standort (in der Regel dein Land) zu schätzen, damit Karte, Angebote und Sprache der Oberfläche standardmäßig auf deinen Standort eingestellt sind. Dies ist eine Schätzung und kann ungenau sein; du kannst Land, Stadt und Sprache jederzeit ändern, und jede solche Wahl hat Vorrang. Präziser GPS-Standort wird nur verwendet, wenn du \"In meiner Nähe\" antippst und die Erlaubnis erteilst. IP-basierte Standortschätzungen werden nur kurz gespeichert, um wiederkehrende Besuche zu beschleunigen, und laufen automatisch ab.",
  "lg.analyticsTitle": "Analyse",
  "lg.analyticsBody": "Wir verwenden datenschutzfreundliche Analysesoftware von Drittanbietern (zum Beispiel Plausible Analytics), um zu verstehen, wie die Website genutzt wird – etwa welche Seiten besucht werden und welche Funktionen beliebt sind. Dabei kann ein externer Analyseanbieter anonymisierte, aggregierte Nutzungsdaten in unserem Auftrag verarbeiten. Diese Tools kommen ohne Cookies aus, verfolgen dich nicht über andere Websites hinweg und erstellen kein persönliches Profil von dir. Wir können Analyseanbieter im Laufe der Zeit hinzufügen, ändern oder entfernen.",
  "lg.notResponsibleForDeals": "LytePress ist ausschließlich eine Angebotsplattform. Angebote, Preise, Produkte, Dienstleistungen und Einlösebedingungen werden vollständig von den unabhängigen Unternehmen erstellt, angeboten und eingelöst, die sie veröffentlichen – es sind nicht unsere Angebote. Wir verkaufen, liefern, empfehlen oder garantieren kein Angebot und sind nicht verantwortlich für Verfügbarkeit, Richtigkeit, Qualität, Sicherheit oder Rechtmäßigkeit dessen, was ein Unternehmen anbietet, oder dafür, dass ein Unternehmen ein Angebot ablehnt, ändert oder nicht einlöst. Jeder Kauf oder jede Einlösung ist ein Vertrag zwischen dir und diesem Unternehmen; jede Streitigkeit über ein Angebot besteht zwischen dir und ihnen. Bitte prüfe die Details jedes Angebots und die Bedingungen des Unternehmens, bevor du dich darauf verlässt.",
  "lg.privacyQuestionsReachUs": "Fragen zum Datenschutz? Kontaktiere uns über die Kontaktseite.",
  "lg.whatLytepressChargesFor": "1. Wofür LytePress Gebühren erhebt",
  "lg.dealsAreNotSold": "2. Angebote werden nicht von LytePress verkauft",
  "lg.boostsAndFeaturedPlacements": "4. Boosts und hervorgehobene Platzierungen",
  "lg.howToRequestA": "5. Wie man eine Rückerstattung anfordert",
  "lg.taxesCurrencyAndFees": "6. Steuern, Währung und Gebühren",
  "lg.chargebacks": "7. Rückbuchungen",
  "lg.cancellingYourAccount": "8. Kündigung deines Kontos",
  "lg.contact": "9. Kontakt",
  "lg.usingLytepress": "1. Nutzung von LytePress",
  "lg.accounts": "2. Konten",
  "lg.dealsRedemptions": "3. Angebote & Einlösungen",
  "lg.payments": "4. Zahlungen",
  "lg.acceptableUse": "5. Zulässige Nutzung",
  "lg.changesTermination": "6. Änderungen & Kündigung",
  "dd.savedTo": "Gespeichert in",
  "dd.myDeals": "Meine Angebote",
  "dd.save": "Speichern",
  "dd.saved": "Gespeichert",
  "dd.favourite": "Angebot speichern",
  "dd.backToDeals": "Zurück zu Angeboten",
  "dd.showThisAtCheckout": "Beim Checkout anzeigen",
  "dd.changedYourMindUndo": "Meinung geändert? Rückgängig machen",
  "bp.businessNotFound": "Unternehmen nicht gefunden.",
  "bp.browseBusinesses": "Unternehmen durchsuchen",
  "bp.loading": "Lädt…",
  "bp.allBusinesses": "Alle Unternehmen",
  "bp.noLiveDealsRight": "Momentan keine aktiven Angebote — folge uns, um benachrichtigt zu werden, wenn sie eines posten.",
  "bp.verifiedBusiness": "Verifiziertes Unternehmen",
  "bp.businessLocation": "Standort des Unternehmens",
  "bl.localGlobalMerchants": "Lokale & globale Händler",
  "bl.discoverBusinesses": "Unternehmen entdecken",
  "bl.followYourFavouriteShops": "Folge deinen Lieblingsgeschäften und verpasse kein frisches Angebot.",
  "bl.noBusinessesMatchThese": "Keine Unternehmen entsprechen diesen Filtern.",
  "bl.viewProfile": "Profil ansehen",
  "dsh.seePricesInYour": "Preise in deiner Währung anzeigen",
  "dsh.pickYourCurrencyAnd": "Wähle deine Währung und jedes Angebot zeigt eine sofortige Schätzung in der Währung, die du verwendest.",
  "dsh.chooseCurrency": "Währung wählen…",
  "psx.confirmingYourPayment": "Zahlung wird bestätigt…",
  "psx.thisOnlyTakesA": "Das dauert nur einen Moment.",
  "psx.paymentSuccessful": "Zahlung erfolgreich!",
  "psx.yourUpgradeIsNow": "Dein Upgrade ist jetzt aktiv. Danke, dass du LytePress unterstützt.",
  "psx.goToMyAccount": "Gehe zu Mein Konto",
  "psx.backToPremium": "Zurück zu Premium",
  "pcx.checkoutCancelled": "Checkout abgebrochen",
  "pcx.noWorriesYouHave": "Keine Sorge — dir wurden keine Kosten berechnet.",
  "pcx.backToPremium": "Zurück zu Premium",
  "nf.thisPageTookA": "Diese Seite hat einen Umweg genommen",
  "nf.thePageYouRe": "Die Seite, die du suchst, existiert nicht oder ist möglicherweise abgelaufen. Lass uns zurück zu den guten Sachen kommen.",
  "nf.backHome": "Zurück nach Hause",
  "nf.browseDeals": "Angebote durchsuchen",
  "nf.goBack": "Zurückgehen",
  "cat.exploreByCategory": "Nach Kategorie erkunden",
  "cat.browseAll": "Alle durchsuchen",
  "cat.grabThemFast": "Schnell zugreifen",
  "md.undoGrab": "Grab rückgängig machen",
  "bd.aiSearch": "KI-Suche",
  "bd.findingTheBestMatches": "Die besten Übereinstimmungen finden…",
  "bd.nearMe": "In meiner Nähe",
  "bd.openNow": "jetzt geöffnet",
  "bd.nearMe2": "in meiner Nähe",
  "bd.noExactMatchesSearching": "Keine genauen Übereinstimmungen — suche nach Bedeutung…",
  "lm.googleMapsApiKey": "Google Maps API-Schlüssel nicht konfiguriert.",
  "lm.loadingMap": "Karte wird geladen...",
  "pdx.movePhotoLeft": "Foto nach links verschieben",
  "pdx.movePhotoRight": "Foto nach rechts verschieben",
  "pdx.eGLyte": "z.B. LYTE20",
  "pdx.couldNotLoadDeal": "Angebot konnte nicht geladen werden",
  "pdx.pleaseTryAgain": "Bitte versuche es erneut.",
  "pdx.photosAdded": "Fotos hinzugefügt",
  "ip.addLytepressToYour": "LytePress zu deinem Startbildschirm hinzufügen",
  "ip.addToHomeScreen": "Zum Startbildschirm hinzufügen",
  "ip.fasterAccessToDeals": "Schnellerer Zugang zu Angeboten in deiner Nähe und deinen Einlöse-Codes – kein App-Store erforderlich.",
  "rev.verifiedReviews": "Verifizierte Bewertungen",
  "rev.verifiedRedemption": "Verifizierte Einlösung",
  "rev.redeemOneOfThis": "Löse eines der Angebote dieses Unternehmens im Geschäft ein, um eine verifizierte Bewertung abzugeben.",
  "rev.noReviewsYetBe": "Noch keine Bewertungen – sei der Erste, nachdem du ein Angebot eingelöst hast.",
  "rev.shareHowTheDeal": "Teile, wie das Angebot war (optional)…",
  "rev.replyPubliclyToThis": "Öffentlich auf diese Bewertung antworten…",
  "rev.pickAStarRating": "Wähle eine Sternebewertung",
  "rev.tapStarsToRate": "Tippe 1–5 Sterne, um dieses Unternehmen zu bewerten.",
  "rev.yourVerifiedReviewIs": "Deine verifizierte Bewertung ist jetzt live.",
  "rev.couldnTPostReview": "Bewertung konnte nicht gepostet werden",
  "rev.replyIsEmpty": "Antwort ist leer",
  "rev.writeAShortReply": "Schreibe zuerst eine kurze Antwort.",
  "rev.replyPosted": "Antwort gepostet",
  "rev.shoppersCanNowSee": "Käufer können jetzt deine Antwort sehen.",
  "rev.couldnTPostReply": "Antwort konnte nicht gepostet werden",
  "tm.touristMode": "Touristenmodus",
  "tm.localPrices": "Lokale Preise",
  "tm.noneYet": "noch keine",
  "tm.saveThisBase": "Diese Basis speichern",
  "tm.iMVisitingShow": "Ich besuche – zeige die besten Angebote in meiner Nähe",
  "tm.hotelLandmarkOrAddress": "Hotel, Wahrzeichen oder Adresse…",
  "tm.setBaseLocation": "Basisstandort festlegen",
  "tm.exitTouristMode": "Touristenmodus verlassen",
  "tm.removeBase": "Basis entfernen",
  "tm.touristModeOn": "Touristenmodus aktiviert ✈️",
  "tm.showingDealsNearYou": "Zeige Angebote in deiner Nähe, in deiner Währung, mit Ein-Tap-Routen.",
  "tm.typeTheHotelLandmark": "Gib das Hotel, Wahrzeichen oder Gebiet ein, in dem du bist, um Angebote in der Nähe zu sehen.",
  "tm.baseUpdated": "Basis aktualisiert 📍",
  "tm.placeNotFound": "Ort nicht gefunden",
  "tm.tryAHotelName": "Versuche einen Hotelnamen, ein Wahrzeichen oder eine Adresse.",
  "rpt.reportThisDeal": "Dieses Angebot melden",
  "rpt.tellUsWhatS": "Sag uns, was nicht stimmt, damit unser Team es überprüfen kann.",
  "rpt.reportDeal": "Angebot melden",
  "rpt.addAnyDetailsOptional": "Füge Details hinzu (optional)",
  "rpt.spamOrMisleading": "Spam oder irreführend",
  "rpt.wrongOrFakePrice": "Falscher oder gefälschter Preis",
  "rpt.offensiveOrInappropriate": "Anstößig oder unangemessen",
  "rpt.expiredNoLongerAvailable": "Abgelaufen / nicht mehr verfügbar",
  "rpt.somethingElse": "Etwas anderes",
  "rpt.signInToReport": "Melde dich an, um zu berichten",
  "rpt.pleaseLogInTo": "Bitte melde dich an, um ein Angebot zu melden.",
  "rpt.thanksForTheReport": "Danke für den Bericht",
  "rpt.ourTeamWillReview": "Unser Team wird dieses Angebot überprüfen.",
  "rpt.couldNotSubmitReport": "Bericht konnte nicht eingereicht werden",
  "dlp.mapUnavailableNoApi": "Karte nicht verfügbar (kein API-Schlüssel)",
  "dlp.loadingMap": "Karte wird geladen…",
  "dlp.useBusinessDefaultCurrency": "Standardwährung des Unternehmens verwenden",
  "dlp.openingHoursOverrideOptional": "Öffnungszeiten-Überschreibung (optional)",
  "dlp.placeNotFound": "Ort nicht gefunden",
  "dlp.tryADifferentAddress": "Versuchen Sie eine andere Adresse oder Ortsbezeichnung.",
  "dlp.gpsUnavailable": "GPS nicht verfügbar",
  "dlp.searchAnAddressInstead": "Suchen Sie stattdessen eine Adresse.",
  "dlp.pinnedYourLocation": "Ihren Standort festgelegt",
  "dlp.couldnTGetLocation": "Standort konnte nicht ermittelt werden",
  "dlp.allowLocationAccessOr": "Standortzugriff erlauben oder eine Adresse suchen.",
  "shb.shareDeal": "Angebot teilen",
  "shb.shareThisDeal": "Teilen Sie dieses Angebot",
  "shb.linkCopied": "Link kopiert",
  "shb.shareItWithFriends": "Teilen Sie es mit Freunden!",
  "shb.couldnTCopyLink": "Link konnte nicht kopiert werden",
  "shs.shareMySavings": "Meine Ersparnisse teilen",
  "shs.copied": "Kopiert!",
  "shs.pasteItAnywhereTo": "Fügen Sie es überall ein, um Freunde einzuladen.",
  "shs.couldnTCopy": "Konnte nicht kopieren",
  "shs.myLytepressSavings": "Meine LytePress-Ersparnisse",
  "rgc.monthlyRedemptionGoal": "Monatliches Einlösungsziel",
  "rgc.redemptionsMonth": "Einlösungen / Monat",
  "rgc.setAMonthlyTarget": "Setzen Sie ein monatliches Ziel, um Ihre Einlösungen zu verfolgen und das Team zu motivieren.",
  "rgc.goalReachedNicelyDone": "Ziel erreicht — gut gemacht!",
  "obc.dismissChecklist": "Checkliste schließen",
  "obc.profileLinkCopied": "Profil-Link kopiert",
  "obc.pasteItOnWhatsapp": "Fügen Sie es in den WhatsApp-Status, die Instagram-Bio oder Ihr Schaufenster ein.",
  "obc.hereSYourLink": "Hier ist Ihr Link",
  "obc.addYourLogo": "Fügen Sie Ihr Logo hinzu",
  "obc.addAContactNumber": "Fügen Sie eine Telefonnummer hinzu",
  "obc.pinYourLocation": "Ihren Standort festlegen",
  "obc.postYourFirstDeal": "Posten Sie Ihr erstes Angebot",
  "obc.shareYourProfileLink": "Teilen Sie Ihren Profil-Link",
  "rr.alertsEnabled": "Benachrichtigungen aktiviert",
  "rr.youLlBeNotified": "Sie werden über neue Angebote benachrichtigt (Demo).",
  "pc.popularDestinations": "Beliebte Ziele",
  "sb.logOut": "Abmelden",
  "st.para1": "Wir glauben, dass es einfach, lohnend und für alle zugänglich sein sollte, großartige lokale Unternehmen zu entdecken.",
  "st.para2": "Jeden Tag bringen Unternehmen neue Produkte auf den Markt, erstellen Sonderangebote, veranstalten Events, führen Aktionen durch und bieten wertvolle Dienstleistungen an, von denen viele Kunden nie erfahren. Gleichzeitig suchen Verbraucher ständig nach Möglichkeiten, Geld zu sparen, neue Erfahrungen zu entdecken und sich mit ihren Gemeinschaften zu verbinden.",
  "st.para3": "Wir haben LytePress geschaffen, um diese beiden Welten zusammenzubringen.",
  "st.para4": "LytePress ist eine Plattform, auf der lokale Unternehmen Aktionen, Veranstaltungen, Verlosungen, Sonderangebote und Möglichkeiten präsentieren können, während Verbraucher neue Wege entdecken, um zu sparen, einzukaufen, zu essen, zu erkunden und sich mit den Unternehmen um sie herum zu engagieren.",
  "st.para5": "Wir setzen uns auch dafür ein, unnötigen Abfall zu reduzieren, indem wir Unternehmen helfen, überschüssige und fast abgelaufene Produkte zu bewerben, die noch Wert haben, und so Vorteile für sowohl Unternehmen als auch Verbraucher zu schaffen.",
  "st.valSupportLocal": "Gemeinschaften mit den Unternehmen um sie herum verbinden.",
  "st.valWasteLess": "Überschüssige und fast abgelaufene Produkte bewerben, die noch Wert haben.",
  "st.valCommunity": "Eine wachsende Gemeinschaft, die kluges Ausgeben und Unternehmertum belohnt.",
  "st.sustainable": "Nachhaltig",
  "an.nViews": "{n} Ansichten",
  "an.nViewsNDeals": "{v} Ansichten · {d} Angebote",
  "an.nSharesNViews": "{s} Shares · {v} Ansichten",
  "dc.seeAllIn": "Alle {name} Angebote ansehen",
  "acc.nOfMLiveDeals": "{n} / {m} aktive Angebote",
  "cat.nLiveDeals": "{n} aktive Angebote",
  "cat.nCategories": "{n} Kategorien",
  "bl.allCategories": "Alle Kategorien",
  "reg.and": "und",
  "acc.planLabelPlan": "{plan} Plan",
  "acc.showInCurrency": "In {code} anzeigen — {label}",
  "home.slide1a": "Tolle Angebote.",
  "home.slide1b": "Weniger Abfall.",
  "home.slide1sub": "Entdecke Angebote von lokalen Unternehmen und rette bald ablaufende Artikel, bevor sie weg sind.",
  "home.slide1badge": "Bis zu 70% sparen",
  "home.slide2a": "Lokal Einkaufen.",
  "home.slide2b": "Mehr Sparen.",
  "home.slide2sub": "Unterstütze lokale Unternehmen und finde die Angebote, die sie in deiner Nähe haben.",
  "home.slide2badge": "Bis zu 60% Rabatt",
  "home.slide3a": "Alle Angebote.",
  "home.slide3b": "An einem Ort.",
  "home.slide3sub": "Alle Kategorien an einem Ort, damit du nie ein lokales Angebot verpasst.",
  "home.slide3badge": "Blitz 50% Rabatt",
  "home.vp1t": "Geld sparen",
  "home.vp1x": "Tolle Rabatte auf deine Lieblingsartikel",
  "home.vp2t": "Abfall reduzieren",
  "home.vp2x": "Hilf Unternehmen, Lebensmittel- und Produktabfälle zu reduzieren",
  "home.vp3t": "Lokal unterstützen",
  "home.vp3x": "Stärke lokale Unternehmen in deiner Gemeinschaft",
  "home.slideN": "Slide {n}",
  "vf.title": "Unternehmensverifizierung",
  "vf.riskyNote": "Diese Kategorien benötigen eine Verifizierung, bevor Sie darin posten können: {list}",
  "vf.upload": "Dokument hochladen",
  "vf.sent": "Dokumente gesendet",
  "vf.sentMsg": "Wir werden sie überprüfen und Ihnen eine E-Mail senden – normalerweise innerhalb eines Tages.",
  "vf.failed": "Konnte das nicht senden",
  "vf.pendingMsg": "Wir überprüfen Ihre Dokumente – wir senden Ihnen eine E-Mail, wenn es fertig ist.",
  "vf.verifiedMsg": "Ihr Unternehmen ist verifiziert. Das blaue Abzeichen wird in Ihrem Profil und im Verzeichnis angezeigt.",
  "vf.rejected": "Wir konnten Ihr Unternehmen anhand dieser Dokumente nicht verifizieren. Versuchen Sie klarere Fotos.",
  "vf.independent": "Unabhängiger Verkäufer",
  "vf.verifiedTag": "Verifiziertes Unternehmen",
  "bl.allCountries": "Alle Länder",
  "bl.nDeals": "{n} Angebote",
  "sidebar.plusActive": "Elite aktiv",
  "sidebar.forLife": "Für immer",
  "cat.Bakery": "Bäckerei",
  "cat.Electronics": "Elektronik",
  "cat.Food & Beverages": "Essen & Getränke",
  "cat.Groceries": "Lebensmittel",
  "cat.Health & Beauty": "Gesundheit & Schönheit",
  "cat.Restaurants": "Restaurants",
  "bl.nBusinesses": "{n} Geschäfte",
  "cat.subScoped": "Durchstöbere handverlesene Angebote in jeder Kategorie in {scope}. Tippe auf ein Feld, um einzutauchen.",
  "cat.subGlobal": "Durchstöbere handverlesene Angebote in jeder Kategorie aus der ganzen Welt. Tippe auf ein Feld, um einzutauchen.",
  "cat.nLiveRightNow": "{n} gerade live",
  "browse.verifiedOnly": "Nur verifiziert",
  "bl.verifiedOnly": "Nur verifiziert",
  "map.verifiedOnly": "Nur verifiziert",
  "browse.emptyVerified": "Hier gibt es noch keine verifizierten Geschäfte mit aktuellen Angeboten – versuche, „Nur verifiziert“ auszuschalten.",
  "trust.whatsThis": "Was ist das?",
  "trust.title": "Was „verifiziert“ bedeutet",
  "trust.verifiedTitle": "Verifiziertes Geschäft",
  "trust.independentTitle": "Unabhängiger Verkäufer",
  "trust.limitsTitle": "Was es nicht verspricht",
  "trust.limitsBody": "Das Abzeichen bezieht sich darauf, wer sie sind, nicht auf eine Garantie für das Produkt, die Dienstleistung oder den Preis. Überprüfen Sie immer die Angebotsbedingungen, bevor Sie kaufen.",
  "trust.reportTitle": "Etwas falsch?",
  "trust.reportBody": "Tippen Sie auf Bericht bei einem Angebot. Zwei Berichte kennzeichnen es für unser Team, und wir entfernen Angebote, die Käufer irreführen.",
  "trust.footer": "Empfindliche Kategorien — Gesundheit, Veranstaltungen, Technik und Automobil — können nur von verifizierten Unternehmen gepostet werden.",
  "apl.title": "Entscheidung anfechten",
  "apl.subtitle": "Etwas haben wir falsch gemacht? Antworte einmal und wir klären das hier.",
  "apl.appeal": "Anfechtung",
  "apl.send": "Anfechtung senden",
  "apl.cancel": "Abbrechen",
  "apl.reason": "Unser Grund",
  "apl.placeholder": "Erzähle uns, was passiert ist – je spezifischer, desto schneller können wir es beheben.",
  "apl.onceNote": "Du kannst jede Entscheidung einmal anfechten. Wir antworten per E-Mail.",
  "apl.sent": "Anfechtung gesendet",
  "apl.sentMsg": "Wir schauen uns das an und schreiben dir eine E-Mail.",
  "apl.failed": "Konnte nicht gesendet werden",
  "apl.pending": "Wir prüfen deine Anfechtung",
  "apl.granted": "Erledigt – wir stimmen dir zu",
  "apl.declined": "Wir haben unsere Entscheidung beibehalten",
  "apl.deal": "Angebot entfernt: {title}",
  "apl.watch": "Deine Angebote werden überprüft, bevor sie live gehen",
  "apl.watchDetail": "Das passiert, nachdem zwei Angebote entfernt wurden.",
  "apl.suspension": "Dein Konto ist gesperrt",
  "apl.verification": "Überprüfung wurde nicht genehmigt",
  "qa.appeal_short": "Bitte erzähle uns, was passiert ist, in mindestens 20 Zeichen – das hilft uns, das schnell zu klären.",
  "qa.appeal_once": "Du hast dies bereits einmal angefochten – wir antworten per E-Mail.",
  "acc.activeDeals": "Aktive Angebote",
  "acc.totalViews": "Gesamtansichten",
  "acc.totalClaims": "Gesamtansprüche",
  "acc.nClaims": "{n} Ansprüche",
  "acc.nConversion": "{n} Konversion",
  "acc.goesLive": "Geht live {when}",
  "adn.title": "Add-ons — zahle nur, was du brauchst",
  "adn.sub": "Die Pakete enthalten alles, was uns nichts kostet. Diese hier sind begrenzt oder machen echte Arbeit, deshalb gibt es sie einzeln — einmalig, ohne Abo.",
  "adn.slotsTitle": "5 zusätzliche Deal-Plätze",
  "adn.slotsBody": "Fünf weitere Plätze für aktive Deals zusätzlich zu deinem Paket, 30 Tage lang. Jederzeit nachkaufbar — sie summieren sich.",
  "adn.slotsCta": "5 Plätze hinzufügen — {price}",
  "adn.slotsActive": "{n} zusätzliche Plätze aktiv",
  "adn.boostTitle": "Deal boosten",
  "adn.boostCta": "Über Mein Konto boosten",
  "adn.verifyTitle": "Vorrangige Verifizierung",
  "adn.verifyBody": "Deine Unterlagen rutschen an den Anfang der Prüfliste, statt zu warten, bis sie dran sind.",
  "adn.verifyCta": "Vorrangige Prüfung — {price}",
  "adn.verifyDone": "Du hast vorrangige Prüfung — deine Unterlagen kommen zuerst.",
  "adn.verifiedAlready": "Dein Geschäft ist bereits verifiziert.",
  "adn.oneOff": "Einmalige Zahlungen, keine Abos",
  "srv.title": "Wofür würdest du zuerst zahlen?",
  "srv.sub": "Tippe alles an, was zutrifft. Deine Antworten entscheiden, was wir als Nächstes bauen und was es kostet.",
  "srv.slots": "Mehr Deal-Plätze",
  "srv.analytics": "Auswertungen & Vergleich",
  "srv.placement": "Top-Platzierung",
  "srv.verification": "Verifiziert-Abzeichen",
  "srv.followers": "Follower benachrichtigen",
  "srv.saved": "Danke — notiert.",
  "bo.title": "Dieses Angebot boosten",
  "bo.checking": "Wir prüfen, was in deiner Nähe frei ist…",
  "bo.slotsLine": "{n} von {limit} gesponserten Plätzen frei im Umkreis von {km}km",
  "bo.choose": "Auswählen",
  "bo.note": "Eine Liste zeigt nie mehr als 3 gesponserte Angebote, deshalb wechseln sich die Geschäfte stündlich oben ab. Exklusiv ist die einzige Option, die man nicht teilt.",
  "bo.boostTitle": "Boost",
  "bo.boostBody": "Einer von 3 gesponserten Plätzen für 7 Tage, für Kunden im Umkreis von 10km.",
  "bo.reachTitle": "Boost + Reichweite",
  "bo.reachBody": "Derselbe Platz, aber du erscheinst auch bis 25km — für Geschäfte, zu denen man fährt.",
  "bo.exclTitle": "Exklusiv",
  "bo.exclBlocked": "Exklusiv braucht alle Plätze frei, und {n} Boost(s) laufen noch. Frei am {date}.",
  "bst.kindReach": "Reichweite {km}km",
  "bst.kindExclusive": "Exklusiv",
  "bst.shareCrowded": "{n} weitere Boosts überlappten dein Gebiet, du hattest also etwa {pct}% der Zeit einen Top-Platz. Mit Exklusiv wäre es die ganze Zeit gewesen.",
  "bst.shareClear": "Du hattest die ganze Zeit einen Top-Platz — in der Nähe gab es keine Konkurrenz.",
  "tfa.enable2fa": "2FA aktivieren",
  "fn.title": "Wie Käufer durch Ihre Angebote navigieren",
  "fn.subtitle": "Drei echte Schritte. Kein erfundenes Konversions-Score.",
  "fn.views": "Aufrufe",
  "fn.grabs": "Eingesammelt",
  "fn.redeemed": "Im Geschäft eingelöst",
  "fn.viewsNote": "Anzahl der Öffnungen Ihrer Angebotsseiten — einmal pro Käufer und Tag gezählt.",
  "fn.grabsNote": "Käufer, die auf Eingesammelt getippt haben, damit das Angebot in ihrer Tasche gespeichert wird.",
  "fn.redeemedNote": "Codes, die Sie im Geschäft gescannt haben — der einzige Schritt, der einen echten Besuch beweist.",
  "fn.grabRate": "{n}% der Aufrufe",
  "fn.redeemRate": "{n}% der Eingesammelt",
  "fn.honestTitle": "Was diese Zahlen Ihnen sagen können und was nicht",
  "fn.honestBody": "Wir können nur die geöffneten Angebotsseiten, Eingesammelt und die Codes, die Sie im Geschäft scannen, zählen. Wir können keine Walk-Ins sehen, die nie ein Angebot eingesammelt haben, was ein Kunde ausgegeben hat oder ob sie zurückgekommen sind. Angebote ohne einen Code haben keinen eingelösten Schritt.",
  "fn.sourcesTitle": "Woher Ihre Aufrufe kamen",
  "fn.sourcesEmpty": "Noch keine Aufrufquellen. Teilen Sie ein Angebot und schauen Sie später wieder vorbei.",
  "fn.sourcesNote": "Shares sind Links, die Sie oder Käufer verschickt haben. Direkt bedeutet, dass wir nicht feststellen konnten, wo der Besuch begonnen hat.",
  "fn.last30Days": "Letzte 30 Tage",
  "fn.nViewsPercent": "{n} Aufrufe · {p}%",
  "fn.nGrabs": "{n} Eingesammelt",
  "fn.nRedeemed": "{n} eingelöst",
  "fn.directionsTitle": "{n} Personen haben nach dem Weg gefragt",
  "fn.directionsNote": "Tipps auf Wegbeschreibung von der Karte oder der Angebotsseite — das stärkste Zeichen, dass jemand zu deinem Geschäft aufgebrochen ist.",
  "fn.nDirections": "{n} Wegbeschreibungen",
  "map.homeMapNote": "Die Kartenansicht ist gerade dein Zuhause",
  "map.classicHome": "Klassisches Zuhause",
  "map.homeClassicNote": "Bevorzugst du die Karte als deinen Startbildschirm?",
  "map.openMap": "Kartenstart verwenden",
  "map.alertMe": "Hier benachrichtigen",
  "map.alertSignIn": "Melde dich kostenlos an, um Benachrichtigungen für dieses Gebiet zu erhalten.",
  "map.alertSaved": "Du bekommst eine Benachrichtigung für {area}",
  "map.alertSavedDesc": "{n} Angebote sind hier jetzt aktiv, innerhalb von etwa {km} km. Verwende die Verwaltung unter Folgen.",
  "map.alertFailed": "Konnte die Gebietswarnung nicht speichern. Bitte versuche es erneut.",
  "map.thisArea": "Dieses Gebiet",
  "map.areasSection": "Gebietsbenachrichtigungen ({n})",
  "map.areaRadius": "Innerhalb von etwa {km} km",
  "map.areaRemoved": "Benachrichtigungen für {area} deaktiviert",
  "map.shareDialogTitle": "Teile diese Kartenansicht",
  "map.sharePreview": "{n} Angebote in Sicht — bis zu {best}% sparen",
  "map.sharePreviewNote": "So wird ungefähr der Link aussehen, wenn jemand ihn erhält.",
  "map.shareNoteLabel": "Füge eine Notiz hinzu (optional)",
  "map.shareNotePlaceholder": "Mittagessen — treffen wir uns bei der Konditorei?",
  "map.shareNow": "Link teilen",
  "map.boostedPin": "Boosted",
  "map.shareCancel": "Abbrechen",
  "home.mapTitle": "Angebote auf der Karte",
  "home.mapSubtitle": "{n} Angebote markiert, wo du tatsächlich vorbeigehen kannst",
  "home.mapOpenFull": "Öffne die vollständige LyteMap",
  "home.mapNote": "Rote Pins enden innerhalb von 24 Stunden. Goldrand-Pins werden vom Geschäft hervorgehoben.",
  "ct.subject": "Betreff",
  "ct.sending": "Senden…",
  "ct.messageTooShort": "Bitte fügen Sie ein wenig mehr Details hinzu, damit wir helfen können.",
  "ct.messageFailed": "Wir konnten das nicht senden",
  "ct.tryAgainLater": "Bitte versuchen Sie es in einem Moment erneut.",
  "ct.replyNote": "Wir lesen jede Nachricht und antworten normalerweise innerhalb eines Werktages.",
  "lg.boostsIntro": "Ein Boost kauft Aufmerksamkeit für ein festes Zeitfenster, daher ist das Timing wichtig.",
  "lg.boostStartsNowLabel": "Es beginnt in dem Moment, in dem du bezahlst:",
  "lg.boostStartsNow": "ein Boost wird sofort für dein Angebot aktiv und läuft für die Tage, die du gekauft hast, daher kann es nach dem Kauf nicht storniert werden. Wenn du einen versehentlich kaufst, kontaktiere uns am selben Tag und wir klären das.",
  "lg.refundTimeline": "Kartenzahlungen werden von unserem Zahlungsanbieter (Stripe) bearbeitet — wir sehen oder speichern deine Kartendaten nie. Genehmigte Rückerstattungen werden auf die gleiche Karte zurückgesendet und erscheinen normalerweise innerhalb von 5–10 Werktagen, abhängig von deiner Bank.",
  "bst.reportTitle": "Was deine Boosts bewirkt haben",
  "bst.reportSub": "Jeder Boost neben dem gleichen Zeitraum kurz bevor er begann.",
  "bst.running": "Läuft",
  "bst.finished": "Beendet",
  "bst.directionsShort": "Wegbeschreibung",
  "bst.reportNote": "Boosted Deals wechseln sich oben ab – die Reihenfolge rotiert jede Stunde, damit jeder boosted Shop einen fairen Anteil erhält.",
  "bst.slotsLeft": "{n} von {limit} Boost-Slots für {category} in {city} gerade frei",
  "bst.slotsFull": "Alle {limit} Boost-Slots für {category} in {city} laufen bereits",
  "bst.slotsNote": "Wir begrenzen aktive Boosts auf {limit} im Umkreis von {km}km um jedes Geschäft, damit eine goldene Nadel heraussticht.",
  "bst.slotsLeftNear": "{n} von {limit} Boost-Slots für {category} im Umkreis von {km}km um dein Geschäft frei",
  "bst.slotsFullNear": "Alle {limit} Boost-Slots für {category} im Umkreis von {km}km um dein Geschäft laufen bereits",
  "bst.nextFree": "Der nächste Slot wird {when} frei — ein Boost läuft ab dem Kauf volle 7 Tage.",
  "bst.notifyMe": "Benachrichtige mich, wenn ein Slot frei wird",
  "bst.notifyQueued": "Du stehst auf der Liste — wir schreiben dir, sobald ein {category}-Slot frei wird.",
  "bst.ownBoostLive": "\"{title}\" hat in {category} schon einen Boost — ein aktiver Boost pro Kategorie, so bietest du nie gegen dich selbst.",
  "adn.boostBody": "Oben in Durchsuchen, Suchen, der Karte, Bald endend und den Angebotsreihen auf der Startseite für 7 Tage. Nur 3 Boosts laufen gleichzeitig innerhalb von 10 km von deinem Geschäft, damit das Abzeichen weiterhin Bedeutung hat.",
  "bo.exclBody": "Du nimmst alle 3 Plätze und rankst bis 25 km: dein Angebot ist das einzige gesponserte Angebot in deiner Kategorie in der Nähe. Maximal zwei Wochen, dann öffnet sich die Kategorie wieder.",
  "bo.close": "Schließen",
  "adn.featTitle": "Auf der Startseite hervorgehoben",
  "adn.featBody": "Dein Angebot belegt den einzigen hervorgehobenen Platz seiner Kategorie auf der Startseite für 24 Stunden — das einzige hervorgehobene Angebot in dieser Kategorie, Käufern weltweit gezeigt. Boost hebt dich in Durchsuchen, der Karte und der Suche; Hervorgehoben bringt dich auf die Startseite.",
  "adn.featCta": "Hervorheben von Mein Konto",
  "card.sponsored": "Gesponsert",
  "lg.listingDiscretion": "Damit LytePress weiterhin geöffnet wird, überprüfen wir, was veröffentlicht wird. Wir können jede Anzeige bearbeiten, archivieren oder entfernen und den Zugang zum Dienst zurückziehen, wenn wir es für notwendig halten — zum Beispiel bei Inhalten, die ungenau, unsicher, dupliziert oder fehl am Platz erscheinen. Normalerweise informieren wir das Geschäft darüber, obwohl wir nicht zuerst fragen müssen.",
  "lg.listingModerationRecords": "Inhalte, die du veröffentlichst — Angebote, Fotos und Geschäftsdaten — werden im Rahmen des Betriebs des Dienstes überprüft, und eine Kopie einer Anzeige, die wir entfernen, kann für eine gewisse Zeit in unseren internen Aufzeichnungen bleiben, damit wir Einsprüche, Streitigkeiten und wiederkehrende Probleme bearbeiten können.",
  "lg.termsOfUse": "Nutzungsbedingungen",
  "lg.privacyPolicy": "Datenschutzrichtlinie",
  "bo.excl14Title": "Exklusiv · 2 Wochen",
  "bo.excl14Body": "Der gleiche Ausschluss, im Voraus für die gesamte zweiwöchige Dauer bezahlt und günstiger als zwei einzelne Wochen. Danach öffnet sich die Kategorie wieder für alle.",
  "bo.extendTitle": "Diese Förderung verlängern",
  "bo.extendLine": "Läuft bis {date} — zusätzliche Tage werden hinten angehängt, du verlierst nichts.",
  "bo.addDays": "{n} Tage hinzufügen",
  "bo.extendNote": "Zusätzliche Tage beginnen, wenn deine aktuelle Laufzeit endet, sodass dein Angebot nie mitten in der Woche aus den gesponserten Plätzen fällt.",
  "bo.exclRunway": "Du hast Exklusiv für {held} von {max} Tagen in Folge gehalten. Die Kategorie öffnet sich wieder für alle bis {date}.",
  "sr.title": "Gesponserte Plätze in deiner Nähe",
  "sr.sub": "Es gibt nur {limit} gesponserte Plätze gleichzeitig in jeder Kategorie innerhalb von {km}km von deinem Geschäft. Hier ist, was gerade frei ist.",
  "sr.loading": "Überprüfe die Plätze rund um dein Geschäft…",
  "sr.open": "{n} von {limit} frei innerhalb von {km}km",
  "sr.full": "Alle {limit} laufen gerade",
  "sr.fullNext": "Alle {limit} laufen — der nächste öffnet am {date}",
  "sr.exclusiveHeld": "Ein Geschäft hält Exklusiv hier bis {date}",
  "sr.watch": "Beobachten",
  "sr.watching": "Beobachte",
  "sr.watchOn": "Wir benachrichtigen dich, sobald ein {category} Platz frei wird",
  "sr.watchOff": "Beobachtung von {category} gestoppt",
  "sr.buyPass": "Kaufe einen Boost Pass — {price}",
  "sr.passesHeld": "{n} Boost Pass bereit zur Nutzung",
  "sr.note": "Ein Boost Pass ist ein im Voraus bezahlter Boost zum normalen Preis — halte ihn, bis ein Platz frei wird, und nutze ihn dann mit einem Klick. Er läuft nie ab und überspringt nicht die Warteschlange, sodass die Obergrenze fair bleibt.",
  "fp.title": "Hier ist dein hervorgehobener Platz",
  "fp.honest": "Dies ist der einzige hervorgehobene Platz für deine Kategorie — das einzige hervorgehobene Angebot, das Käufer dort sehen, weltweit.",
  "fp.note": "Hervorgehoben ist die Front-Page-Reihe — ein Platz pro Kategorie. Wähle dein Land (von lokalen Käufern gesehen) oder weltweit (überall gesehen). Läuft 24 Stunden; ein erneuter Kauf während der Laufzeit fügt am Ende einen weiteren Tag hinzu.",
  "fp.reachLocal": "Mein Land",
  "fp.reachLocalNote": "Ganz oben in deiner Kategorie für Käufer hier",
  "fp.reachGlobal": "Weltweit",
  "fp.reachGlobalNote": "Ganz oben in deiner Kategorie überall",
  "fp.today": "Heute (jetzt starten)",
  "fp.pickDay": "Heute starten oder einen Tag vorbuchen",
  "fp.notNow": "Nicht jetzt",
  "fp.buy": "Hervorheben — {price}",
  "bo.extendSame": "Fügt {n} weitere Tage zu deinem aktuellen Angebot hinzu.",
  "bo.extendToReach": "Fügt {n} Tage hinzu und erweitert deine Reichweite von 10 km auf 25 km für die gesamte Laufzeit.",
  "bo.extendToExclusive": "Fügt {n} Tage hinzu und nimmt alle 3 gesponserten Plätze bis zu 25 km ein.",
  "bo.extendNarrower": "Fügt Tage hinzu, verkleinert aber deine Reichweite wieder auf 10 km.",
  "pc.placeholder": "Rabattcode",
  "pc.apply": "Anwenden",
  "pc.remove": "Code entfernen",
  "pc.invalid": "Dieser Code ist ungültig.",
  "pc.appliedPct": "{code} — {n}% Rabatt",
  "pc.appliedAmt": "{code} — ${n} Rabatt",
  "pc.haveCode": "Hast du einen Rabattcode?",
  "prc.f2": "Ein Karten-Pin & öffentliches Profil",
  "prc.p3": "Bis zu 3 angeheftete Standorte",
  "acc.frontPageForDays": "7 Tage hervorgehoben",
  "br.limitNote": "{plan} deckt {cap} angeheftete Standorte ab. Pro hat 3 und Elite ist unbegrenzt.",
  "br.overLimit": "Sie haben mehr Standorte gespeichert, als {plan} abdeckt ({cap}). Alles, was bereits veröffentlicht wurde, bleibt auf der Karte — upgraden Sie, um Änderungen hier zu speichern.",
  "acc.archived": "Archiviert",
  "acc.archivedWhy": "Entfernt:",
  "acc.archivedNoReason": "Es wurde kein Grund angegeben — frag uns und wir erklären es dir.",
  "acc.explainAppeal": "Erkläre, was passiert ist →",
  "sl.shareMsg": "Wir haben gerade {n} Angebote — schau mal rein:",
  "sl.copy": "Link kopieren",
  "sl.copied": "Link kopiert",
  "sl.copiedNote": "Füge ihn überall ein — er öffnet direkt auf deiner Shop-Seite.",
  "bst.kindFeatured": "Auf der Startseite vorgestellt, {km}km",
  "bo.extendLocked": "Du betreibst {kind} — füge Tage hinzu, damit du es nicht verlierst. Du kannst wechseln, sobald die Laufzeit endet.",
  "fp.slots": "Der hervorgehobene Platz für deine Kategorie ist frei — sichere ihn dir für 24 Stunden.",
  "fp.full": "Der hervorgehobene Platz für deine Kategorie ist gerade belegt — der nächste öffnet am {date}. Es gibt einen Platz pro Kategorie.",
  "prc.chipFeatured": "Priorisierte Platzierung",
  "prc.chipCredits": "Boosts & Hervorgehobene als Zusatzoptionen",
  "prc.boostLeft": "{n} Boost-Pässe verbleibend",
  "prc.p5": "Aktionsberichte zu jedem Boost oder Hervorgehobenen",
  "prc.boostBody": "Boosts und Hervorgehobene Platzierungen sind nie in einem Plan enthalten — kaufen Sie sie nur, wenn Sie sie benötigen. Boosten Sie ein einzelnes Angebot für {price}, um es für 7 Tage an die Spitze von Durchsuchen und der Karte zu pinnen — finden Sie die Boost-Schaltfläche bei Ihren Angeboten in",
  "acc.usedBoostPass": "Boost-Pass verwendet — {n} verbleibend.",
  "acc.couldNotUseYour": "Konnte Ihren Boost-Pass nicht verwenden",
  "prc.plusIncludesPro": "Alles in Pro, plus:",
  "prc.b4": "Prioritätsunterstützung — deine Nachrichten springen die Warteschlange",
  "sl.title": "Dein Shop-Link",
  "sl.sub": "Ein Link für alles, was du hast — {n} gerade live. Füge ihn in WhatsApp ein und es zeigt deinen Shop-Namen, dein Logo und wie viele Angebote aktiv sind.",
  "sl.on": "Link aktiv",
  "sl.off": "Link inaktiv",
  "sl.switchedOn": "Dein Shop-Link ist live",
  "sl.switchedOff": "Dein Shop-Link ist inaktiv",
  "sl.offNote": "Dein Link ist deaktiviert, daher wird er für niemanden geöffnet. Schalte ihn wieder ein, wann immer du wieder teilen möchtest.",
  "sl.needVerified": "Shop-Links kommen mit einer Verifizierung — das verhindert, dass jemand anders unter deinem Namen handelt. Schicke deine Dokumente ein und deiner wird automatisch aktiviert, basierend auf deinem Firmennamen.",
  "sl.getVerified": "Verifizieren lassen",
  "sl.dealLinks": "Jedes Angebot erhält auch seinen eigenen Link — hier ist „{title}“:",
  "prc.b3": "Priorisierte Platzierung in Durchsuchen & auf der Karte, fair geteilt",
  "prc.sp3": "Die Limits für Live-Angebote zählen Angebote, die veröffentlicht oder geplant sind und noch nicht abgelaufen — Kostenlos 2, Pro 15, Elite 100. Elite deckt auch 25 angeheftete Standorte ab. Diese Obergrenzen sind fair use, kein Hindernis: Wenn Ihre Kette mehr benötigt, senden Sie eine E-Mail an den Support und wir erhöhen sie in Ihrem Konto. Die priorisierte Platzierung ist ein Entscheidungskriterium zwischen Angeboten, die die gleiche Entfernung zum Käufer haben, fair geteilt zwischen Elite-Geschäften — sie stellt niemals ein Geschäft über eines, das tatsächlich näher ist.",
  "prc.firstTermOnly": "{price} für diesen Zeitraum mit Ihrem Code — verlängert sich zu {full}",
  "prc.promoTermOnly": "Codes gelten für den Zeitraum, den Sie kaufen. Verlängerungen werden automatisch zum üblichen Preis berechnet, der Rabatt gilt also nur für diesen ersten Zeitraum.",
  "prc.sp2": "Pläne verlängern sich automatisch, damit Ihr Shop nie stillsteht. Sie zahlen für einen Zeitraum (Pro {pro} / 30 Tage oder {proYear} / Jahr; Elite {plus} / 30 Tage oder {plusYear} / Jahr); Ihre Karte wird sicher von unserem Zahlungsdienstleister Stripe gespeichert und zu Beginn jedes neuen Zeitraums automatisch belastet — bis Sie die automatische Verlängerung deaktivieren, was Sie jederzeit auf dieser Seite tun können. Wenn eine Verlängerungszahlung fehlschlägt, läuft Ihr Plan während einer Kulanzfrist von 3 Tagen weiter, während wir es erneut versuchen. Ein Rabattcode gilt nur für den Zeitraum, in dem er verwendet wird — Verlängerungen werden zum Listenpreis berechnet. Pläne beinhalten niemals Boosts oder hervorgehobene Platzierungen: das sind einmalige Gebühren, keine Abonnements.",
  "lg.proSubscription": "Plan (Pro oder Elite)",
  "lg.placementShoppersUseLytepress": "Platzierung, plus eine kleine Anzahl von einmaligen Add-Ons (zusätzliche Deal-Slots, ein Boost Pass oder priorisierte Verifizierung). Käufer nutzen LytePress kostenlos.",
  "lg.ifYouReNot": "Wenn Sie mit einem Plan nicht zufrieden sind, fragen Sie uns innerhalb von",
  "lg.afterDaysASubscription": "Ein Plan wird für einen Zeitraum (30 Tage oder ein Jahr) gekauft und verlängert sich automatisch. Ihre Karte wird sicher von unserem Zahlungsdienstleister Stripe gespeichert — niemals von uns — und zu Beginn jedes neuen Zeitraums belastet, damit Ihr Plan ohne Unterbrechung weiterläuft. Sie können die automatische Verlängerung jederzeit auf der Preisseite deaktivieren; Sie behalten alles, wofür Sie bezahlt haben, bis der aktuelle Zeitraum endet, und danach wird nichts mehr berechnet. Wenn eine Verlängerungszahlung fehlschlägt, laufen die Vorteile Ihres Plans während einer Kulanzfrist von 3 Tagen weiter, während wir es erneut versuchen, danach wechselt das Konto zu Kostenlos. Nach 14 Tagen ist eine Zahlung für einen bereits laufenden Zeitraum nicht erstattungsfähig, und Sie behalten alles, wofür Sie bezahlt haben, bis dieser Zeitraum endet.",
  "lg.ifARenewalCharge": "Ein Rabattcode gilt nur für den Zeitraum, in dem er verwendet wurde: Verlängerungen werden zum Listenpreis berechnet. Sie können Ihr Verlängerungsdatum einsehen und die automatische Verlängerung jederzeit auf der Preisseite deaktivieren. Falls Sie eine Verlängerung überrascht, kontaktieren Sie uns — wenn ein bezahlter Zeitraum ungenutzt bleibt, erstatten wir ihn normalerweise aus Kulanz.",
  "lg.premiumSubscriptionsAndDeal": "Pläne, Boosts, hervorgehobene Platzierungen und Add-Ons werden über unseren Zahlungsdienstleister abgerechnet. Boosts und hervorgehobene Platzierungen sind niemals in einem Plan enthalten — sie sind separate einmalige Käufe und in jeder Region begrenzt, sodass eine Platzierung nur verfügbar ist, solange ein Slot in der Nähe Ihres Geschäfts frei ist. Elite Deals und Standortzulassungen sind faire Nutzungsobergrenzen, und \"priorisierte Platzierung\" bedeutet nur, dass ein Elite Deal zuerst angezeigt wird, wenn zwei Deals den gleichen Abstand zum Käufer haben — es stellt niemals ein Geschäft über eines, das tatsächlich näher ist. Gebühren werden vor dem Kauf angezeigt. Steuern können je nach Ihrem Standort anfallen. Rückerstattungen werden durch unser",
  "lg.accountDetailsNameEmail": "Kontodaten (Name, E-Mail, Rolle), Geschäftsinformationen (Geschäftsname, Kategorie, Standort, Kontaktnummern, Logo/Deckblatt) und Ihre Präferenzen (angezeigte Währung, gefolgte Geschäfte, Standort). Wenn Sie die Zwei-Faktor-Authentifizierung aktivieren, speichern wir ein verschlüsseltes Geheimnis und gehashte Wiederherstellungscodes. Wenn Sie einen Passkey hinzufügen, speichern wir dessen öffentlichen Schlüssel und einen Signaturzähler. Wenn Sie Feedback oder eine Support-Nachricht senden, behalten wir die Nachricht und Ihre E-Mail nur, wenn Sie eine angegeben haben, damit wir antworten können.",
  "lg.businessContactDetailsAre": "Die Kontaktdaten des Unternehmens werden nur öffentlich angezeigt, wenn das Unternehmen entscheidet, sie öffentlich zu machen. Der öffentliche Link eines verifizierten Geschäfts (/s/shop-name) und seine Deal-Links zeigen den Namen, das Logo und die aktiven Deals dieses Geschäfts jedem mit dem Link — das Geschäft kann diesen Link jederzeit deaktivieren. Wir verkaufen Ihre persönlichen Daten nicht. Wir teilen begrenzte Daten mit unserem Zahlungsdienstleister, um Käufe abzuschließen.",
  "lg.passwordsAreHashedFa": "Passwörter werden gehasht, Zwei-Faktor-Geheimnisse werden im Ruhezustand verschlüsselt, und sensible Aktionen sind zeitlich begrenzt. Wenn Sie einen Passkey hinzufügen, speichern wir nur dessen öffentlichen Schlüssel und einen Zähler — niemals Ihren Fingerabdruck, Ihr Gesicht oder Ihre Geräte-PIN, die Ihr Gerät niemals verlassen. Kein System ist perfekt sicher, also verwenden Sie bitte ein starkes Passwort und fügen Sie einen Passkey oder 2FA hinzu.",
  "lg.youCanEditYour": "Sie können Ihr Profil bearbeiten, Ihre öffentlichen Kontaktdaten ausblenden, vertrauenswürdige Geräte und Passkeys verwalten, 2FA ein- oder ausschalten, Ihren öffentlichen Shop-Link deaktivieren und Benachrichtigungen jederzeit in Mein Konto anpassen. Um Ihr Konto und Ihre persönlichen Daten zu löschen, senden Sie eine E-Mail an support@lytepress.com und wir werden dies innerhalb von 30 Tagen umsetzen.",
  "lg.proSubscriptionsDayMoney": "3. Pläne — wie die Abrechnung funktioniert und 14 Tage Geld-zurück-Garantie",
  "lg.lawDisputes": "7. Recht & Streitigkeiten",
  "lg.termsContact": "8. Kontakt",
  "auth.or": "oder",
  "fb.button": "Feedback",
  "fb.title": "Sagen Sie uns, was Sie denken",
  "fb.sub": "Alles, was kaputt, fehlt oder großartig ist — es kommt direkt zu uns. Kein Konto erforderlich.",
  "fb.typeBug": "Etwas ist kaputt",
  "fb.typeIdea": "Ich habe eine Idee",
  "fb.typeCompliment": "Etwas, das ich liebe",
  "fb.typeOther": "Etwas anderes",
  "fb.messagePlaceholder": "Sagen Sie uns, was passiert ist oder was Sie sehen möchten…",
  "fb.emailLabel": "E-Mail (optional — nur damit wir antworten können)",
  "fb.send": "Absenden",
  "fb.sent": "Danke — das ist bei uns",
  "fb.sentNote": "Eine Person liest jede dieser Nachrichten. Wir antworten, wenn Sie eine E-Mail hinterlassen haben.",
  "fb.failed": "Konnte das nicht senden",
  "fb.tooShort": "Ein paar mehr Worte und wir wissen, was wir beheben sollen",
  "pk.title": "Passkeys",
  "pk.sub": "Melden Sie sich mit Face ID, Ihrem Fingerabdruck oder Ihrer Geräte-PIN an. Ihr Passwort funktioniert weiterhin als Backup.",
  "pk.add": "Einen Passkey hinzufügen",
  "pk.added": "Passkey hinzugefügt",
  "pk.addedNote": "Beim nächsten Mal tippen Sie auf \"Mit einem Passkey anmelden\" — kein Passwort zum Eingeben.",
  "pk.removed": "Passkey entfernt",
  "pk.remove": "Entfernen",
  "pk.none": "Noch keine Passkeys. Fügen Sie einen hinzu und dieses Gerät kann Sie ohne Passwort anmelden.",
  "pk.unsupported": "Dieser Browser unterstützt Passkeys noch nicht — Ihr Passwort und 2FA funktionieren weiterhin normal.",
  "pk.cancelled": "Abgebrochen",
  "pk.failed": "Das hat nicht funktioniert",
  "pk.lastUsed": "Zuletzt verwendet am {date}",
  "pk.never": "Noch nicht verwendet",
  "pk.signIn": "Mit einem Passkey anmelden",
  "pk.loginFailed": "Konnte Sie nicht anmelden",
  "pk.loginFailedNote": "Versuchen Sie Ihr Passwort oder fügen Sie zuerst einen Passkey aus Mein Konto hinzu.",
  "cq.need": "Brauchen Sie mehr Platz?",
  "cq.title": "Höhere Limits anfragen",
  "cq.sub": "Elite deckt {deals} aktive Deals und {branches} Standorte als faire Nutzung ab. Sagen Sie uns, was Ihre Kette tatsächlich benötigt, und wir werden es festlegen.",
  "cq.deals": "Aktive Deals, die Sie benötigen",
  "cq.branches": "Standorte, die du brauchst",
  "cq.notePlaceholder": "Was sollten wir wissen – wie viele Filialen du betreibst, was du planst…",
  "cq.send": "Anfrage senden",
  "cq.sentTitle": "Anfrage gesendet",
  "cq.sentNote": "Wir schauen uns das an und senden dir eine E-Mail – normalerweise innerhalb eines Tages.",
  "cq.pending": "Höhere Limits angefragt – wir senden dir eine E-Mail",
  "cq.failed": "Konnte das nicht senden",
  "fb.context": "Sende die Seite und das Gerät, auf dem ich bin",
  "fb.contextOn": "Hilf uns, es nachzustellen: {path}, plus Bildschirmgröße, Sprache und Browser. Keine Cookies oder persönlichen Daten.",
  "fb.contextOff": "Wir erhalten nur deine Nachricht.",
  "pn.title": "Sperre deinen Shop für dieses Gerät",
  "pn.body": "Deine Angebote sind aktiv. Füge einen Zugangscode hinzu, und nur dein Gesicht, Fingerabdruck oder Geräte-PIN können in diesen Shop gelangen – kein Passwort zum Raten oder Stehlen.",
  "pn.add": "Einen Zugangscode hinzufügen",
  "pn.notNow": "Nicht jetzt",
  "tm.sortingAround": "Angebote in der Nähe von {place} sortieren.",
  "tm.cancel": "Abbrechen",
  "tm.nearPlace": "in der Nähe von {place}",
  "tm.you": "du",
  "tm.changeBase": "Basis ändern",
  "tm.yourBases": "Deine Basen:",
  "tm.switchedTo": "Wechsel zu {label}",
  "pw.placeholder": "Passwort",
  "pw.show": "Passwort anzeigen",
  "pw.hide": "Passwort verbergen",
  "pw.veryWeak": "Zu schwach",
  "pw.weak": "Schwach",
  "pw.fair": "Geht so",
  "pw.strong": "Stark",
  "pw.veryStrong": "Sehr stark",
  "pw.crackTime": "würde {time} dauern, um geknackt zu werden",
  "pw.needsWork": "Noch nicht stark genug",
  "prc.bestValue": "BESTER WERT",
  "qa.profanity": "Bitte entferne zuerst die Schimpfwörter — wir haben {words} gefunden. LytePress wird von Familien und Mitarbeitern im Einzelhandel gelesen, daher bleiben Angebote und Bewertungen sauber.",
  "sl.customTitle": "Wähle deinen eigenen Link",
  "sl.customPlus": "Inklusive bei Elite — wähle die Wörter nach /s/ selbst.",
  "sl.customOwned": "Du besitzt dieses Add-on — ändere die Wörter nach /s/ wann immer du willst.",
  "sl.customOffer": "Dein Link wird aus deinem Firmennamen erstellt. Willst du andere Wörter nach /s/? Es kostet {price} einmalig, gehört dir für immer — oder kostenlos bei Elite.",
  "sl.customBuy": "Nenne meinen Link — {price}",
  "sl.customEdit": "Bearbeite meinen Link",
  "sl.customSave": "Link speichern",
  "sl.customCancel": "Abbrechen",
  "sl.customPlaceholder": "dein-shop-name",
  "sl.customSaved": "Dein neuer Link ist aktiv",
  "adn.linkTitle": "Wähle deinen eigenen Shop-Link",
  "adn.linkBody": "Wähle die Wörter nach /s/ selbst anstelle deines Firmennamens — kürzer auszusprechen, einfacher einzufügen. Gehört dir für immer, eine Zahlung.",
  "adn.linkCta": "Nenne meinen Link — {price}",
  "adn.linkIncluded": "Inklusive bei Elite",
  "adn.linkSetIt": "Setze meinen Link",
  "adn.linkNeedsVerify": "Shop-Links benötigen eine Verifizierung — sende zuerst deine Dokumente ein.",
  "rst.thisResetLinkIs": "Dieser Rücksetzlink ist ungültig, bereits verwendet oder abgelaufen. Bitte fordere einen neuen an bei",
  "rst.minChars": "Verwende mindestens {n} Zeichen für dieses Konto.",
  "acc.tabDeals": "Meine Angebote",
  "acc.tabShop": "Mein Geschäft",
  "acc.tabRedeem": "Einlösen",
  "acc.tabAccount": "Konto",
  "sec.title": "Anmeldedaten",
  "sec.sub": "Ändere das Passwort oder die E-Mail, mit der du dich anmeldest.",
  "sec.pwTitle": "Passwort",
  "sec.pwNote": "Die Änderung meldet alle anderen Geräte ab.",
  "sec.pwCta": "Passwort ändern",
  "sec.currentPw": "Aktuelles Passwort",
  "sec.newPw": "Neues Passwort",
  "sec.pwSave": "Passwort speichern",
  "sec.pwChanged": "Passwort geändert",
  "sec.pwChangedNote": "Alle anderen Geräte wurden abgemeldet.",
  "sec.emailTitle": "Anmelde-E-Mail",
  "sec.emailCta": "E-Mail ändern",
  "sec.newEmail": "Neue E-Mail-Adresse",
  "sec.emailSave": "Bestätigung senden",
  "sec.emailConfirmNote": "Wir senden einen Link an die neue Adresse. Nichts ändert sich, bis du darauf tippst.",
  "sec.emailSent": "Überprüfe dein neues Postfach",
  "sec.emailSentNote": "Wir haben einen Bestätigungslink an {email} gesendet. Er ist 24 Stunden gültig.",
  "sec.emailPending": "Warten auf die Bestätigung von {email}.",
  "ses.title": "Angemeldete Geräte",
  "ses.sub": "Melde alles ab, was du nicht erkennst.",
  "ses.idleNote": "Automatisch nach {n} Stunden Inaktivität abgemeldet.",
  "ses.thisDevice": "Dieses Gerät",
  "ses.signOutAll": "Überall abmelden",
  "ses.signOutDevice": "Dieses Gerät abmelden",
  "ses.signedOutDevice": "Dieses Gerät wurde abgemeldet",
  "ses.signedOutAll": "Überall abgemeldet",
  "ses.signedOutAllNote": "Alle anderen Geräte müssen sich erneut anmelden.",
  "ses.empty": "Keine anderen Geräte sind angemeldet.",
  "auth.endedIdle": "Du wurdest nach einer Inaktivitätsperiode abgemeldet. Melde dich an, um dort fortzufahren, wo du aufgehört hast.",
  "auth.endedRevoked": "Dieses Gerät wurde abgemeldet. Melde dich erneut an, um fortzufahren.",
  "pd.maxDays": "Ihr Plan läuft ein Angebot bis zu {n} Tagen. Erneuern Sie es mit einem Tipp, wenn es endet.",
  "acc.renew": "Erneuern",
  "acc.renewTitle": "Dieses Angebot mit einem frischen Countdown zurück auf die Karte bringen",
  "acc.renewDone": "Countdown zurückgesetzt",
  "acc.renewRelisted": "Wieder auf der Karte",
  "acc.renewNote": "Dieses Angebot läuft noch {n} Tage.",
  "pd.clampedTitle": "Enddatum vorgezogen",
  "pd.clampedNote": "Ihr Plan läuft einen Deal für bis zu {n} Tage, daher endet dieser hier. Erneuern Sie ihn mit einem Tipp, um ihn fortzusetzen.",
  "nd.title": "Hier gibt es noch keine Angebote",
  "nd.sub": "Sag uns, wo du bist, und wir bringen die Geschäfte auf die Karte in deiner Nähe. So entscheiden wir, wo wir als Nächstes anklopfen.",
  "nd.townPlaceholder": "Deine Stadt, z.B. Arima",
  "nd.emailPlaceholder": "E-Mail (optional — wir informieren dich, wenn Angebote eintreffen)",
  "nd.cta": "Ich möchte hier Angebote",
  "nd.thanks": "Notiert",
  "nd.thanksNote": "Wir haben {place} zur Liste hinzugefügt.",
  "nd.onTheList": "Du bist auf der Liste",
  "nd.onTheListNote": "Wir senden dir eine E-Mail, sobald Geschäfte in deiner Nähe anfangen, Angebote zu posten.",
  "map.shareNear": "Teile die nächsten Angebote",
  "map.shareNearMsg": "Angebote in der Nähe von {place} gerade jetzt auf LytePress:",
  "promo.title": "\"Wir sind auf LytePress\" Grafik",
  "promo.sub": "Ein quadratisches Bild mit deinem QR-Code — poste es auf Instagram, Facebook oder deinem WhatsApp-Status.",
  "promo.cta": "Bild herunterladen",
  "promo.saved": "Bild gespeichert",
  "promo.savedNote": "Poste es, und jeder, der scannt, landet direkt bei deinen Angeboten.",
  "acc.weeklyRoundup": "Wöchentlicher Rückblick",
  "acc.dealsNearYouWeekly": "Angebote in deiner Nähe, einmal pro Woche",
  "acc.fiveClosestDeals": "Die fünf nächsten aktiven Angebote, einmal pro Woche per E-Mail. Nicht mehr als das.",
  "acc.digestOn": "Wöchentlicher Rückblick aktiv",
  "acc.digestOff": "Wöchentlicher Rückblick deaktiviert",
  "acc.digestOnNote": "Wir senden dir einmal pro Woche die nächsten Angebote per E-Mail.",
  "acc.digestOffNote": "Keine wöchentlichen E-Mails mehr. Kontoe-Mails werden weiterhin gesendet.",
  "cat.Travel & Tours": "Reisen & Touren",
  "sr.watchAnother": "Eine weitere Kategorie ansehen:",
  "sr.pickCategory": "Wähle eine Kategorie",
  "prc.startFree": "Jetzt kostenlos starten — keine Karte erforderlich",
  "prc.switchAtTermEnd": "Wechsel zu {plan}, wenn meine Laufzeit endet",
  "prc.noProration": "Keine anteilige Abrechnung — Ihre aktuelle Laufzeit ist bereits bezahlt, der Wechsel erfolgt also erst nach Ablauf.",
  "prc.cancelScheduled": "Geplanten Wechsel abbrechen",
  "prc.scheduled": "Geplant: {plan}",
  "prc.scheduledOn": "Es tritt am {date} in Kraft. Bis dahin ändert sich nichts.",
  "prc.scheduleCancelled": "Geplanter Wechsel abgebrochen — es ändert sich nichts.",
  "prc.scheduledBanner": "Sie wechseln zu {plan} am {date}. Alles, was Sie bezahlt haben, bleibt bis dahin aktiv.",
  "del.title": "Mein Konto löschen",
  "del.subShopper": "Entfernt dein Konto, gespeicherte Codes, Favoriten und Sitzungen. Bewertungen, die du hinterlassen hast, bleiben im Shop als „Gelöschter Benutzer“.",
  "del.subBusiness": "Du kannst löschen, sobald du keine aktiven oder geplanten Angebote und keine laufende bezahlte Laufzeit mehr hast. Dann wird alles entfernt: dein Shop, Angebote, Fotos und Pins.",
  "del.cta": "Mein Konto löschen",
  "del.warning": "Dies ist dauerhaft. Wir können das Konto, deine Angebote oder deine Fotos nicht wiederherstellen.",
  "del.passwordPlaceholder": "Dein Passwort",
  "del.typeDelete": "Gib DELETE ein, um zu bestätigen",
  "del.confirmCta": "Dauerhaft löschen",
  "del.keepAccount": "Mein Konto behalten",
  "del.done": "Konto gelöscht",
  "del.doneNote": "Alles wurde entfernt. Danke, dass du LytePress ausprobiert hast.",
  "lg.deletingYourAccount": "7. Dein Konto löschen",
  "lg.deleteShopper": "Käufer können ihr Konto jederzeit in Mein Konto löschen. Dies entfernt das Konto, gespeicherte Codes, Favoriten und aktive Sitzungen. Bewertungen, die du geschrieben hast, bleiben im Profil des Shops, angezeigt als „Gelöschter Benutzer“, da die Bewertung eines Shops auch Informationen für andere Käufer ist.",
  "lg.deleteBusiness": "Unternehmen können ein Konto nur löschen, wenn es keine aktiven oder geplanten Angebote und keine laufende bezahlte Laufzeit mehr hat. Dies schützt Käufer davor, Karten-Pins für einen Shop zu finden, der nicht mehr existiert, und schützt dich davor, Zeit zu verlieren, für die du bereits bezahlt hast: lösche oder lasse deine Angebote auslaufen, kündige die Verlängerung und lösche, sobald die Laufzeit endet. Schreibe uns, wenn du früher gehen musst.",
  "lg.deleteAdmin": "Wir können ein Konto selbst schließen — zum Beispiel bei wiederholten Verstößen gegen die Richtlinien oder Betrug — auch wenn es aktive Angebote hat. Wir werden dir den Grund per E-Mail mitteilen, wenn wir das tun.",
  "msg.title": "Nachrichten",
  "msg.sub": "Alles, was wir dir senden, landet hier — antworte in der App und es kommt direkt zu uns.",
  "msg.new": "neu",
  "msg.noSubject": "Nachricht",
  "msg.you": "Du",
  "msg.replyPlaceholder": "Schreibe deine Antwort…",
  "msg.send": "Antwort senden",
  "msg.sent": "Antwort gesendet — wir melden uns bei dir.",
  "prc.b5": "Dein eigener Shop-Link, lytepress.com/s/dein-name (verifizierte Shops)",
  "sec.nudgeTitle": "Sichere deinen Shop mit einem Passwort",
  "sec.nudgeBody": "Dein Konto enthält deine Angebote, deine Preise und deine Zahlungshistorie. Ein Passwort (Face ID oder Fingerabdruck) oder ein Zwei-Schritt-Code macht ein gestohlenes Passwort nutzlos.",
  "sec.nudgePasskey": "Füge ein Passwort hinzu",
  "sec.nudge2fa": "Aktiviere die Zwei-Schritt-Verifizierung",
  "st.mission": "Unsere Mission ist einfach: Menschen helfen, weniger für die Dinge auszugeben, die sie bereits kaufen, lokalen Geschäften helfen, ruhige Zeiten zu füllen, und weniger Lebensmittel und Lagerbestände zu verschwenden.",
  "an.lockedTitle": "Pro-Insights sind gesperrt",
  "an.lockedCta": "Sieh dir an, was Pro hinzufügt",
  "af.footerLink": "Analytik",
  "af.badge": "Shop-Analytik",
  "af.title": "Was deine Analytik dir zeigt",
  "af.subtitle": "Jeder Shop erhält die Hauptzahlen. Pro und Elite fügen die Coaching-Ebene hinzu – Trends, Timing und Benchmarks.",
  "af.colMetric": "Was du siehst",
  "af.colFree": "Kostenlos",
  "af.colPaid": "Pro & Elite",
  "af.rowTotals": "Aktive, abgelaufene und bald ablaufende Angebote",
  "af.rowTraffic": "Gesamtansichten, Grabs, Shares und Follower",
  "af.rowDiscount": "Durchschnittlicher Rabatt und Konversionsrate",
  "af.rowCategory": "Ansichten nach Kategorie aufgeschlüsselt",
  "af.rowTopDeals": "Deine Top-Angebote Rangliste",
  "af.rowFunnel": "Trichter: Ansichten zu Grabs zu Einlösungen",
  "af.rowRedemptions": "Gesamtanzahl der Einlösungen und genommenen Routen",
  "af.rowGoal": "Monatlicher Einlösungsziel-Tracker",
  "af.rowTrends": "Ansichten, Shares und Follower-Trends über die Zeit",
  "af.rowBestTime": "Beste Zeit und bester Tag zum Posten",
  "af.rowWoW": "Woche-zu-Woche Bewegung",
  "af.rowBenchmark": "Wie deine Rabatte im Vergleich zu nahegelegenen Shops abschneiden",
  "af.rowRedemptionDetail": "Einlösungsdetails für jedes Angebot",
  "af.rowMostShared": "Meist-geteilte Rangliste",
  "af.note": "Pro und Elite sehen genau die gleichen Analytiken – es gibt nichts, was für den größeren Plan zurückgehalten wird. Bei Kostenlos erscheinen die gesperrten Zeilen weiterhin, verschwommen, sodass du immer weißt, was vorhanden ist.",
  "af.seePlans": "Pläne und Preise ansehen",
  "af.openMine": "Meine Analytik öffnen",
  "af.compareLink": "Sieh dir an, welche Analytik jeder Plan dir bietet",
  "an2.doNext": "Mach das als Nächstes",
  "an2.tipNearExpiry": "{n} Angebot(e) laufen in 48 Stunden ab — verlängere sie oder schärfe den Preis, bevor sie verfallen",
  "an2.tipDiscount": "Deine Rabatte liegen etwa {gap}% unter den Geschäften in deiner Nähe — versuche {target}% bei deinem nächsten Angebot",
  "an2.tipBestTime": "Deine Käufer schauen sich um {time} am {day} um — poste dein nächstes Angebot kurz davor",
  "an2.tipRedeem": "Nur {rate}% der ergriffenen Codes werden im Geschäft genutzt — eine Erinnerung oder eine Frist schließt diese Lücke",
  "an2.tipViewsDown": "Die Aufrufe sind um {n}% im Vergleich zur letzten Woche gesunken — ein frisches Angebot hebt sie schneller als alles andere",
  "an2.tipGrabRate": "Nur {rate}% der Zuschauer ergreifen deine Angebote — ein schärferer Preis oder ein klareres Foto behebt das normalerweise",
  "an2.tipShares": "Niemand hat deine Angebote bisher geteilt — sende deinen Shop-Link einmal an deine eigenen Kunden und sieh, was passiert",
  "an2.tipAllGood": "Heute muss nichts repariert werden — deine Zahlen sind gesund. Poste etwas Frisches, um sie so zu halten",
  "an2.proMore": "Pro erledigt den Rest für dich",
  "an2.grabs": "Codes ergriffen",
  "an2.subVsLastWeek": "{n}% im Vergleich zur letzten Woche",
  "an2.subOfViews": "{n}% der Zuschauer ergreifen",
  "an2.subOfGrabs": "{n}% der eingelösten",
  "an2.subExpired": "{n} abgelaufen",
  "an2.trend": "Trend",
  "an2.mViews": "Aufrufe",
  "an2.mRedemptions": "Einlösungen",
  "an2.mShares": "Teilen",
  "an2.mFollowers": "Follower",
  "an2.noTrendData": "Hier gibt es noch nichts dazu.",
  "an2.followersChip": "{n} Follower",
  "an2.dealTable": "Wie jedes Angebot läuft",
  "an2.colDeal": "Angebot",
  "an2.colViews": "Aufrufe",
  "an2.colGrabs": "Ergriffen",
  "an2.colRedeemed": "Eingelöst",
  "an2.colRate": "Quote",
  "an2.colShares": "Teilen",
  "an2.tableNote": "Quote ist die Anzahl der eingelösten Codes aus den ergriffenen Codes. Eine hohe Quote bedeutet, dass das Angebot wirklich konvertiert — wiederhole es oder booste es.",
  "an2.tipNearExpiryOne": "Ein Angebot läuft in 48 Stunden ab — verlängere es oder schärfe den Preis, bevor es verfällt",
  "an2.tableNoteFree": "Pro fügt Einlösungen, Einlösungsraten und Shares für jedes Angebot in dieser Tabelle hinzu.",
  "af.rowActions": "„Mach das als Nächstes“ — die Verbesserungen, die sich lohnen, basierend auf deinen Zahlen",
  "af.onePick": "1 von 3",
  "af.rowDealTable": "Ein Tisch: jedes Angebot mit Aufrufen und Abholungen",
  "af.rowCompetition": "Nahegelegene Konkurrenten und ihre Rabatte, nebeneinander",
  "pd2.moreOptions": "Weitere Optionen",
  "pd2.moreHint": "Diese bleiben so, wie du sie beim letzten Mal gelassen hast, also benötigen die meisten Angebote nur ein Foto, einen Titel und einen Preis.",
  "pd2.codesOn": "Codes aktiv",
  "pd2.featuredOn": "Hervorgehoben",
  "pd2.endToday": "Heute",
  "pd2.end3": "In 3 Tagen",
  "pd2.end7": "In 7 Tagen",
  "pd2.end14": "In 14 Tagen",
  "pd2.endPick": "Wähle ein Datum",
  "pd2.endsAt": "Endet am {date} um {time} ({gmt})",
  "pd2.exactTime": "Genauer Endzeitpunkt",
  "pd2.addSpot": "Einen anderen Ort festlegen",
  "pd2.descHint": "Darauf entscheiden sich die Käufer. {n} weitere Zeichen benötigt.",
  "pd2.descOk": "Darauf entscheiden sich die Käufer — gute Länge.",
  "pd2.writeForMe": "Schreib es für mich",
  "pd2.undoDraft": "Rückgängig machen",
  "pd2.draftFailed": "Konnte gerade keinen Entwurf schreiben",
  "pd2.photoFirst": "Füge zuerst ein Foto hinzu, dann beschreibt der Entwurf, was tatsächlich darin ist.",
  "pd2.draftNoPhoto": "Nur vom Titel geschrieben — füge ein Foto hinzu für einen klareren Entwurf.",
  "pc.yourPlan": "{plan} Plan",
  "pc.freeForever": "Kostenlos, so lange Sie möchten.",
  "pc.lifetime": "Ihr Leben lang — keine Erneuerung.",
  "pc.renews": "Erneuert am {date}",
  "pc.autoRenewsOn": "Verlängert sich automatisch am {date}",
  "pc.autoRenewOff": "Automatische Verlängerung aus — Plan endet am {date}",
  "pc.cancelAutoRenew": "Automatische Verlängerung deaktivieren",
  "pc.resumeAutoRenew": "Automatische Verlängerung wieder aktivieren",
  "pc.updateCard": "Karte aktualisieren",
  "pc.renewNow": "Jetzt verlängern",
  "pc.graceMsg": "Jetzt verlängern — Ihr Tarif ist abgelaufen; Vorteile enden in {n} Tagen.",
  "pc.billingFail": "Das Abrechnungsportal konnte nicht geöffnet werden. Bitte erneut versuchen.",
  "pc.renewOffToast": "Automatische Verlängerung deaktiviert — Ihr Plan läuft bis zum Enddatum",
  "pc.renewOnToast": "Automatische Verlängerung wieder aktiviert",
  "pc.renewFail": "Automatische Verlängerung konnte nicht geändert werden. Bitte erneut versuchen.",
  "pc.buyDeals": "Zusätzliche Angebote kaufen",
  "bh.title": "Abrechnungsverlauf",
  "bh.subtitle": "Jede Abbuchung mit einem Belegcode, den du uns zur Bestätigung eines Kaufs nennen kannst.",
  "bh.loading": "Belege werden geladen…",
  "bh.empty": "Noch keine Zahlungen.",
  "bh.invoice": "Rechnung",
  "bh.paid": "bezahlt",
  "bh.pending": "unabgeschlossen",
  "bh.refunded": "erstattet",
  "pc.upgrade": "Upgrade",
  "pc.nOfMThisMonth": "{n} von {m} Angeboten in diesem Monat gepostet",
  "pc.unlimitedThisMonth": "Unbegrenzte Angebote in diesem Monat",
  "pc.nLeft": "{n} übrig",
  "pc.noneLeft": "Keine mehr übrig in diesem Monat",
  "pc.resets": "Ihr Kontingent wird am {date} zurückgesetzt",
  "pc.creditsHeld": "Zusätzliche Angebote gehalten",
  "pc.nCreditsHeld": "{n} zusätzliche Angebote gehalten",
  "pc.locations": "Standorte festgelegt",
  "pc.nBought": "{n} gekauft",
  "pc.maxDays": "Tage, an denen ein Angebot gültig sein kann",
  "pc.creditNote": "Zusätzliche Angebote werden nur verwendet, wenn Ihr monatliches Kontingent aufgebraucht ist, und sie laufen nie ab.",
  "tu.title": "Brauchen Sie diesen Monat mehr Angebote?",
  "tu.sub": "Zusätzliche Angebote laufen nie ab und werden nur verwendet, wenn Ihr monatliches Kontingent aufgebraucht ist.",
  "tu.youHold": "Sie halten gerade {n}.",
  "tu.each": "{price} pro Stück",
  "tu.perMonth": "/ 30 Tage",
  "tu.buy": "Kaufen",
  "tu.locationsTitle": "Zusätzliche Kartenstandorte",
  "pc.rolledOver": "Vom letzten Monat übernommen",
  "pc.rollsOverNote": "Unbenutzte Angebote werden bis zu {cap} in den nächsten Monat übertragen.",
  "pc.noRollover": "Kostenlose Rücksetzungen am 1. — bezahlte Pläne übertragen ungenutzte Angebote.",
  "pc.boughtNote": "Gekauft oder verschenkt. Verfallen nie, auch nicht bei Free.",
  "pc.maxDaysShort": "Ein Angebot kann bis zu {n} Tage laufen",
  "prc.f1": "4 Angebote pro Monat, am 1. zurückgesetzt, bis zu 14 Tage jeweils",
  "prc.p1": "30 Angebote pro Monat — ungenutzte verfallen, bis zu 30 Tage jeweils",
  "prc.b1": "150 Angebote pro Monat — ungenutzte verfallen, bis zu 60 Tage jeweils",
  "prc.b2": "25 angeheftete Standorte, und du kannst mehr kaufen",
  "pd2.titleSuggested": "Vorgeschlagener Titel:",
  "pd2.useTitle": "Verwenden",
  "pd2.dismissTitle": "Meinen behalten",
  "pd2.undoTitleChange": "Titel rückgängig machen",
  "pw.placeholder8": "Passwort (mindestens 8 Zeichen)",
  "pw.placeholder12": "Passwort (mindestens 12 Zeichen)",
  "prc.rollFree": "Setzt sich am 1. zurück. Kostenlose Deals verfallen nicht.",
  "prc.rollPro": "Unbenutzte Deals werden einen Monat lang gespeichert, bis zu 30 – ein ruhiger Monat kann dir 60 für den nächsten Monat lassen.",
  "prc.rollPlus": "Unbenutzte Deals werden einen Monat lang gespeichert, bis zu 150 – ein ruhiger Monat kann dir 300 für den nächsten Monat lassen.",
  "prc.rollAddon": "Zusätzliche Deals, die als Add-Ons gekauft werden, verfallen nie.",
  "prc.rolledIn": "{n} von letztem Monat übernommen",
  "acc.emailFreqIntro": "Wie oft sollen wir Ihnen über Angebote und Rabatte per E-Mail schreiben?",
  "acc.freq_instant": "Sofort",
  "acc.freq_instant_note": "Eine E-Mail pro Angebot, maximal jedoch eine pro Tag, damit Sie nicht überflutet werden.",
  "acc.freq_daily": "Einmal täglich",
  "acc.freq_daily_note": "Alles vom Tag in einer E-Mail gebündelt. Empfohlen.",
  "acc.freq_weekly": "Einmal wöchentlich",
  "acc.freq_weekly_note": "Einmal pro Woche eine Zusammenfassung, nichts dazwischen.",
  "acc.freq_off": "Keine Marketing-E-Mail",
  "acc.freq_off_note": "Nichts Werbliches. Sie sehen trotzdem alles in der App.",
  "acc.emailFreqSaved": "E-Mail-Frequenz gespeichert",
  "acc.emailCapNote": "Egal, was Sie wählen, wir senden nie mehr als eine Marketing-E-Mail pro Tag oder drei pro Woche.",
  "an3.withinRadius": "Konkurrenten innerhalb von",
  "an3.anywhere": "Überall",
  "an3.radiusSummary": "{n} {cat} Geschäfte mit aktuellen Angeboten innerhalb von {km} km von Ihrem Standort.",
  "an3.radiusSummaryAny": "{n} {cat} Geschäfte mit aktuellen Angeboten, die nächsten zuerst.",
  "an3.noneInRadius": "Kein anderes {cat} Geschäft hat ein Angebot innerhalb von {km} km von Ihnen — dieser Platz gehört Ihnen.",
  "an3.noneAnywhere": "Kein anderes {cat} Geschäft hat gerade ein aktuelles Angebot — dieser Platz gehört Ihnen.",
  "an3.radiusLocked": "Nahegelegene Konkurrenten nach Entfernung ist eine Pro-Funktion.",
  "an3.radiusNoPin": "Pinnen Sie Ihr Geschäft auf der Karte, und wir können die Geschäfte um Sie herum messen.",
  "an3.pinMyShop": "Mein Geschäft pinnen",
  "pw.acceptWeak": "Ich verstehe, dass dieses Passwort schwach ist und möchte es trotzdem verwenden.",
  "pw.suggest": "Schlag mir ein Passwort vor",
  "pw.memorable": "Leicht zu merken",
  "pw.random": "Zufällig",
  "pw.words": "Wörter:",
  "pw.reroll": "Neuer Vorschlag",
  "pw.copy": "Kopieren",
  "pw.suggestNote": "Verwende es und speichere es sicher. Es erfüllt bereits unsere Sicherheitsregeln.",
  "auth.staffPortal": "Mitarbeiterportal",
  "auth.staffSignIn": "Mitarbeiter-Anmeldung",
  "auth.staffPortalNote": "Melde dich mit deinem Admin-Konto an.",
  "pw.floorNote": "Jedes Passwort benötigt mindestens 8 Zeichen, einen Großbuchstaben und ein Symbol.",
  "tu.credits_5.label": "5 zusätzliche Angebote",
  "tu.credits_5.note": "Fünf zusätzliche Angebote zu deinem monatlichen Kontingent. Sie laufen nie ab.",
  "tu.credits_20.label": "20 zusätzliche Angebote",
  "tu.credits_20.note": "Zwanzig zusätzliche Angebote für je 75 Cent statt 1 Dollar. Sie laufen nie ab.",
  "tu.credits_50.label": "50 zusätzliche Angebote",
  "tu.credits_50.note": "Fünfzig zusätzliche Angebote für je 60 Cent – der günstigste Weg, viele zu posten. Sie laufen nie ab.",
  "tu.branch_1_30d.label": "1 zusätzliche Location",
  "tu.branch_1_30d.note": "Eine weitere Location für 30 Tage festlegen. Kaufe es erneut, um es zu behalten.",
  "tu.branch_5_30d.label": "5 zusätzliche Locations",
  "tu.branch_5_30d.note": "Fünf weitere Locations für 30 Tage festlegen. Kaufe es erneut, um sie zu behalten.",
  "acc.quietTitle": "Ruhige Stunden",
  "acc.quietNote": "Nichts Werbliches landet über Nacht – es wartet auf den Morgen.",
  "acc.quietFrom": "Ruhig von",
  "acc.quietTo": "bis",
  "acc.quietYourTime": "deiner lokalen Zeit",
  "acc.quietSaved": "Ruhige Stunden gespeichert",
  "pw.leaked": "In {n} bekannten Datenpannen gesehen — Angreifer versuchen diese zuerst.",
  "auth.backToLogin": "Zurück zur Anmeldung",
  "auth.demoLabel": "Demo:",
  "acc.nextEmailAt": "Nächste E-Mail: {when}",
  "acc.nextEmailOff": "Wir senden Ihnen keine Werbe-E-Mails.",
  "acc.nextEmailSoon": "jeden Moment",
  "acc.nextEmailToday": "heute nach {time}",
  "acc.nextEmailTomorrow": "morgen nach {time}",
  "acc.nextEmailWaiting": "{n} warten auf die Zusammenstellung",
  "an3.myCategory": "meine Kategorie",
  "lg.asIsTitle": "Service wird wie angeboten bereitgestellt",
  "lg.asIsBody": "LytePress ist eine sich entwickelnde Plattform, und während wir uns bemühen, eine zuverlässige und nahtlose Erfahrung zu bieten, können gelegentliche Fehler oder Ausfälle auftreten. Durch die Nutzung von LytePress erkennen Sie an, dass Sie dies auf eigenes Risiko tun. Wir können keinen unterbrechungsfreien Service garantieren oder die Verantwortung für Verluste übernehmen, die aus der Nutzung der Plattform entstehen. Wenn Sie auf Fehler oder Probleme stoßen, bitten wir Sie, uns zu benachrichtigen, damit wir diese so schnell wie möglich beheben können. Wir schätzen Ihr Verständnis und Ihre Unterstützung, während wir LytePress weiter verbessern.",
  "lg.asIsShort": "LytePress wächst und verändert sich noch. Es wird wie angeboten bereitgestellt — Sie nutzen es auf eigenes Risiko, und wenn etwas nicht funktioniert, lassen Sie es uns bitte wissen, damit wir es beheben können.",
  "lg.passwordRules": "Jedes Passwort muss mindestens 8 Zeichen, einen Großbuchstaben und ein Symbol enthalten und darf nicht Ihren eigenen Namen, den Namen des Geschäfts oder Ihre E-Mail-Adresse enthalten. Shop- und Admin-Konten benötigen 12 Zeichen. Wir überprüfen neue Passwörter gegen öffentliche Listen von geleakten Passwörtern: Ein Shop- oder Admin-Konto kann keines verwenden, das in einem Leak erscheint, und ein Käufer, der ein schwaches oder geleaktes Passwort wählt, muss bestätigen, dass er das Risiko akzeptiert.",
  "lg.quotaTerms": "Bezahlte Pläne beinhalten eine monatliche Anzahl von Angeboten, die Sie posten können (eine Quote), jedoch keine Garantie für Ansichten, Klicks oder Verkäufe. Unbenutzte Angebote in einem bezahlten Plan rollen nur für einen Monat über, begrenzt auf den Wert eines Monats. Angebote, die als Zusatzkäufe erworben werden, laufen nicht ab. Eine Quote ist eine Fair-Use-Obergrenze, und wir können die Obergrenzen mit Vorankündigung anpassen.",
  "lg.aiHelp": "KI-unterstützte Angebotsbeschreibung",
  "lg.aiHelpBody": "Wir bieten ein optionales Tool an, das einen Angebotstitel und eine Beschreibung aus den Details und dem Foto erstellt, die Sie bereitstellen. Der Entwurf ist nur ein Vorschlag: Sie entscheiden, ob Sie ihn verwenden, können ihn bearbeiten oder rückgängig machen, und Sie bleiben für alles verantwortlich, was auf Ihrem Angebot veröffentlicht wird, einschließlich Genauigkeit, Ansprüche und rechtliche Konformität. Ihr Eingabetext und das erste Foto werden an unseren KI-Anbieter gesendet, um den Entwurf zu erstellen. Wir begrenzen, wie viele Entwürfe jeder Shop pro Tag anfordern kann, und können das Tool jederzeit abschalten.",
  "lg.emailsWeSend": "E-Mails, die wir senden",
  "lg.emailsWeSendBody": "E-Mails zu Konto, Sicherheit, Zahlung und Moderation sind Teil des Services und werden immer gesendet. Werbe-E-Mails — neue Angebotsbenachrichtigungen, Zusammenfassungen und Angebote — sind auf eine E-Mail pro Tag und drei pro Woche pro Konto begrenzt, und Sie wählen, wie oft Sie von uns hören (so wie es passiert, täglich, wöchentlich oder gar nicht) sowie Ruhezeiten, in denen keine Werbe-E-Mails gesendet werden. Jede Werbe-E-Mail enthält einen Abmeldelink, und wir senden in der Sprache, die Sie auf der Seite verwenden, wo wir diese Formulierung haben.",
  "lg.quotasAndCredits": "5. Monatliche Quoten und zusätzliche Angebote",
  "lg.quotasAndCreditsBody": "Die monatliche Angebotsquote eines Plans wird am 1. zurückgesetzt. In bezahlten Plänen rollen ungenutzte Angebote nur für einen Monat über, begrenzt auf den Wert eines Monats, und sie haben keinen Geldwert — eine ungenutzte Quote ist nicht erstattungsfähig und kann nicht zwischen Konten übertragen werden. Zusätzliche Angebote oder Standorte, die als Zusatzkäufe erworben werden, sind nicht erstattungsfähig, sobald ein Teil verwendet wurde; wenn keiner verwendet wurde, fragen Sie uns innerhalb von 14 Tagen, und wir erstatten es.",
  "lg.collectLangEmail": "Wir speichern auch die Sprache, in der Sie die Seite lesen (damit unsere E-Mails übereinstimmen), Ihre E-Mail-Häufigkeit und Ruhezeiteinstellungen sowie einen Nachweis darüber, welche Werbe-E-Mails wir Ihnen gesendet haben, damit wir die täglichen und wöchentlichen Obergrenzen einhalten können.",
  "lg.sharingAi": "Wenn Sie das optionale KI-Angebotschreibtool verwenden, werden der eingegebene Text und das erste Foto des Angebots an unseren KI-Anbieter gesendet, um den Entwurf zu erstellen. Wir senden ihnen nicht Ihren Namen, Ihre E-Mail oder Kontodaten, und wir verwenden Ihre Angebote nicht, um die Modelle anderer zu trainieren.",
  "lg.breachCheckPrivacy": "Wenn Sie ein Passwort festlegen, überprüfen wir es gegen öffentliche Listen von geleakten Passwörtern mit einer Methode, bei der nur die ersten fünf Zeichen eines Einweg-Hashes unseren Server verlassen — Ihr Passwort und der vollständige Hash tun dies niemals. Wenn dieser Dienst nicht verfügbar ist, überspringen wir einfach die Überprüfung.",
  "lg.privacyEmailChoices": "Sie steuern die Werbe-E-Mails von Mein Konto: wählen Sie, wie es passiert, täglich, wöchentlich oder keine, setzen Sie Ruhezeiten in Ihrer eigenen Zeitzone oder verwenden Sie den Abmeldelink in jeder Werbe-E-Mail. Konto-, Sicherheits- und Zahlungs-E-Mails können nicht abgeschaltet werden, solange Ihr Konto geöffnet ist.",
  "acc.browseDealsArrow": "Angebote durchstöbern →",
  "acc.verifiedRedemptionsOnly": "Nur verifizierte Einlösungen im Geschäft.",
  "acc.approxIn": "ca. in {cur}",
  "an3.sameSpot": "Gleicher Ort",
  "an3.underTenth": "unter 0,2 km",
  "an3.kmAway": "{km} km entfernt",
  "an3.nearestOf": "nächste von {n} Standorten",
  "an3.rivalsHidden": "{n} konkurrierende Geschäfte haben hier Angebote.",
  "an3.rivalsHiddenNote": "Pro und Elite zeigen dir, wer sie sind, wie weit sie entfernt sind und wie stark sie rabattieren.",
  "an3.liveCount": "{n} live",
  "bo.fitShorter": "Ihr Angebot endet in {days} Tagen, also läuft es {days} statt {full} — zum passenden Preis.",
  "bo.fitTooShort": "Dieses Angebot endet innerhalb eines Tages. Verlängern oder erneuern Sie es zuerst, dann gehört die volle Laufzeit Ihnen.",
  "an3.locationsCount": "{n} Standorte",
  "an3.locationN": "Standort {n}",
  "an3.legendYou": "Du",
  "an3.legendRival": "Rivale · durchschnittlicher Rabatt %",
  "an3.compareRival": "Vergleiche mit meinen Angeboten",
  "auth.agreeCheckbox": "Ich habe die gelesen und stimme der zu",
  "lg.setOutBelow": "unten in den Abrechnungsabschnitten angeben",
  "acc.rivalAlertsTitle": "Sag mir Bescheid, wenn ein Konkurrent tiefer geht",
  "acc.rivalAlertsNote": "Ein Hinweis pro Woche, maximal, wenn ein Geschäft in deiner Kategorie innerhalb von 10 km ein Angebot postet, das mindestens 10 Punkte tiefer ist als dein aktueller Durchschnitt. Nur Pro und Elite.",
  "acc.rivalAlertsOn": "Konkurrentenwarnungen sind aktiv",
  "acc.rivalAlertsOff": "Konkurrentenwarnungen sind deaktiviert",
  "st.asWeExpandThroughout": "Während wir in neuen Städten und Märkten wachsen, ist es unser Ziel, die vertrauenswürdigste Anlaufstelle für die Entdeckung lokaler Angebote, Aktionen, Erlebnisse und Möglichkeiten zu werden.",
  "st.valSustainable": "Nachhaltigen Konsum in jedem Markt, den wir bedienen, fördern.",
  "st.lytepressIsAGrowing": "LytePress ist eine wachsende Gemeinschaft, die Menschen mit lokalen Unternehmen verbindet, kluges Ausgeben belohnt, Unternehmertum unterstützt und nachhaltigen Konsum fördert.",
  "lg.contact2": "8. Kontakt",
  "lg.whoWeAre": "1. Wer wir sind",
  "lg.informationWeCollect": "2. Informationen, die wir sammeln",
  "lg.howWeUseIt": "3. Wie wir es verwenden",
  "lg.location": "4. Standort",
  "lg.sharing": "5. Teilen",
  "lg.security": "6. Sicherheit",
  "lg.yourChoices": "7. Ihre Entscheidungen",
  "lg.whoWeAreBody": "LytePress ist der rechtliche Name der Entität, die diese Plattform betreibt, registriert in Trinidad & Tobago, und ist der Datenverantwortliche für die hier beschriebenen Informationen. Wir bedienen Unternehmen und Käufer weltweit, daher können Ihre Informationen in anderen Ländern von den unter Teilen aufgeführten Anbietern verarbeitet werden. Fragen zu Ihren Daten: support@lytepress.com.",
  "lg.lawDisputesBody": "LytePress ist der rechtliche Name der Einheit, die diese Plattform betreibt und in Trinidad und Tobago registriert ist, während der Service selbst weltweit für Unternehmen und Käufer verfügbar ist — wo wir registriert sind, ist kein Limit für unseren Betrieb. Diese Bedingungen unterliegen den Gesetzen von Trinidad und Tobago, und die dortigen Gerichte haben die Zuständigkeit für Streitigkeiten. Dies beeinträchtigt nicht Ihre Rechte nach dem Verbraucherschutzrecht des Landes, in dem Sie leben, und es schränkt nicht die Länder ein, die LytePress bedient. Sprechen Sie zuerst mit uns unter support@lytepress.com — fast alles wird so schneller geklärt.",
  "lg.plainSummary": "LytePress (\"wir\", \"uns\") ermöglicht es Unternehmen, ihre Angebote zu veröffentlichen, und lässt Käufer die Angebote in ihrer Umgebung finden, wo auch immer sie handeln. Diese Seiten sind absichtlich in einfacher Sprache verfasst, und wenn etwas unklar ist, können Sie eine E-Mail an support@lytepress.com senden, und eine Person wird es erklären. Durch die Nutzung von LytePress stimmen Sie den folgenden Punkten zu.",
  "qa.firstDealPending": "Erster Deal — in Überprüfung",
  "qa.firstDealPendingMsg": "Wir werfen einen kurzen Blick auf den ersten Deal eines neuen Shops, bevor er auf die Karte kommt. Er wird normalerweise innerhalb von ein paar Stunden live geschaltet, und jeder Deal danach wird sofort veröffentlicht.",
  "rpt.notHonoured": "Deal wurde nicht eingehalten",
  "rpt.notHonouredSent": "Bericht gesendet",
  "rpt.notHonouredThanks": "Danke, dass du uns informiert hast",
  "rpt.notHonouredNote": "Das geht direkt an unser Moderationsteam und wir kümmern uns darum.",
  "rpt.notHonouredHelp": "Bist du rein und der Shop hat diesen Deal abgelehnt? Ein Tipp genügt — kein Formular ausfüllen.",
  "ver.title": "Bestätige deine E-Mail, um Angebote zu veröffentlichen",
  "ver.note": "Wir haben einen Link und einen 6-stelligen Code an {email} gesendet. Die Angebote, die du postest, sind bis zur Bestätigung geparkt – sie gehen live, sobald du das tust.",
  "ver.codePlaceholder": "000000",
  "ver.confirmCode": "Bestätigen",
  "ver.resend": "Nochmal senden",
  "ver.sent": "E-Mail ist unterwegs",
  "ver.sentNote": "Überprüfe {email} – der Link und der Code funktionieren beide.",
  "ver.couldNotSend": "Konnte diese E-Mail nicht senden",
  "ver.badCode": "Dieser Code hat nicht funktioniert",
  "ver.done": "E-Mail bestätigt",
  "ver.doneNote": "Du bist bereit – alles, was du geparkt hast, geht jetzt live.",
  "ver.checking": "Bestätige deine E-Mail...",
  "ver.badLink": "Dieser Link hat nicht funktioniert",
  "ver.badLinkNote": "Er könnte abgelaufen oder bereits verwendet worden sein.",
  "ver.useCodeInstead": "Gib den 6-stelligen Code aus der E-Mail im Banner auf deinem Dashboard ein.",
  "ver.noToken": "Dieser Link fehlt der Code.",
  "ver.goToAccount": "Gehe zu meinem Konto",
  "qa.emailPending": "Bestätige zuerst deine E-Mail",
  "qa.emailPendingMsg": "Dein Angebot ist gespeichert und geparkt. Tippe auf den Link in der E-Mail, die wir dir gesendet haben – oder gib den 6-stelligen Code im Banner auf deinem Dashboard ein – und es geht sofort live.",
  "ver.enterCodeHere": "Gib hier den 6-stelligen Code aus der E-Mail ein",
  "ver.manualTitle": "Bestätige deine E-Mail",
  "ver.manualNote": "Öffne die E-Mail, die wir dir geschickt haben, und gib den 6-stelligen Code unten ein. Du musst nicht angemeldet sein.",
  "ver.needANewOne": "E-Mail verloren oder der Code ist abgelaufen?",
  "ver.emailPlaceholder": "Die E-Mail, mit der du dich angemeldet hast",
  "ver.sendNewEmail": "Neue E-Mail senden",
  "ver.emailSentShort": "E-Mail gesendet",
  "vf.unlocks": "Bis du verifiziert bist, kannst du 2 Angebote gleichzeitig von einem Standort aus schalten, und bezahlte Platzierungen bleiben geschlossen. Die Verifizierung hebt alle drei auf.",
  "qa.liveCapTitle": "Das ist dein Limit für aktive Angebote",
  "sr.passNeedsVerification": "Boost-Pässe werden freigeschaltet, sobald Ihr Unternehmen verifiziert ist.",
  "ver.domainTip": "Tipp: Wenn Sie eine Adresse auf Ihrer eigenen Geschäftsdomäne (nicht Gmail oder Hotmail) bestätigen, werden Ihre Live-Angebote und Standortbeschränkungen sofort aufgehoben.",
  "vf.domainTier": "Domänen-E-Mail bestätigt",
  "vf.domainTierNote": "Sie haben einen Code bestätigt, der an {domain} gesendet wurde, eine Adresse auf Ihrer eigenen Geschäftsdomäne, sodass Ihre Handelsgrenzen bereits aufgehoben sind. Die bezahlte Platzierung wartet noch auf Ihre Dokumente.",
  "br.pinFarFromListing": "{branch} ist etwa {distance} km von dem Google-Eintrag entfernt, den wir unter deinem Namen gefunden haben — {listing}, {address}. Wenn der Pin falsch ist, werden Käufer, die auf Wegbeschreibung tippen, an einen Ort geschickt, an dem du nicht bist. Zieh ihn auf deine Tür und speichere.",
  "br.thisPin": "Dieser Pin",
  "fx.title": "Diesen Pin verschieben?",
  "fx.summary": "{business} hat {branch} etwa {distance} km von dem Google-Eintrag, den wir unter deinem Namen gefunden haben — {listing}{address}, angeheftet.",
  "fx.legend": "Rot ist der aktuelle Standort deines Pins. Grün ist der Eintrag. Bestätigen verschiebt den gespeicherten Pin und den gleichen Pin in deinen aktiven Angeboten. Wenn dein Pin richtig ist und der Eintrag jemand anderem gehört, schließe einfach diese Seite — es ändert sich nichts.",
  "fx.confirm": "Ja, verschiebe meinen Pin hierher",
  "fx.now": "Jetzt",
  "fx.listing": "Eintrag",
  "fx.moved": "Pin verschoben",
  "fx.movedNote": "{branch} befindet sich jetzt bei {address}. Deine aktiven Angebote wurden ebenfalls aktualisiert, sodass die Wegbeschreibung die Käufer ab jetzt zum richtigen Ort führt.",
  "fx.yourPin": "Dein Pin",
  "fx.yourListing": "dein Google-Eintrag",
  "fx.aLocation": "einen Standort",
  "fx.expired": "Dieser Link ist abgelaufen",
  "fx.expiredNote": "Ein-Klick-Links sind 14 Tage gültig. Du kannst den Pin weiterhin selbst von Mein Konto verschieben.",
  "fx.cantUse": "Wir können diesen Link nicht verwenden",
  "fx.checking": "Überprüfe diesen Link…",
  "fx.noCode": "Dieser Link fehlt der Code. Öffne die E-Mail erneut.",
  "fx.invalid": "Dieser Link ist nicht mehr gültig.",
  "fx.failed": "Konnte diesen Pin nicht verschieben.",
  "fx.openAccount": "Mein Konto öffnen",
  "fx.byHand": "um jeden Pin manuell zu verschieben.",
  "pv.verifiedOn": "Preis verifiziert am {date}",
  "pv.checkFirst": "Überprüfe den Preis, bevor du gehst",
  "pv.changed": "Käufer sagen, dieser Preis hat sich geändert",
  "pv.tooltip": "Das letzte Mal, dass jemand hinter diesem Preis stand.",
  "pv.countOne": "1 Käufer hat dies bestätigt",
  "pv.countMany": "{n} Käufer haben dies bestätigt",
  "pv.shopperHelp": "Warst du kürzlich dort? Sag allen anderen, ob dieser Preis noch gilt.",
  "pv.ownerHelp": "Ist es immer noch dein Preis? Ein Tipp genügt, um dieses Angebot heute als verifiziert zu kennzeichnen.",
  "pv.signInHint": "Melde dich als Käufer an, um diesen Preis zu bestätigen.",
  "pv.stillRight": "Preis ist immer noch richtig",
  "pv.priceChanged": "Preis geändert",
  "pv.youConfirmed": "Du hast diesen Preis bestätigt.",
  "pv.youFlagged": "Du hast uns gesagt, dass sich dieser Preis geändert hat.",
  "pv.thanksConfirmed": "Danke — Preis verifiziert",
  "pv.thanksConfirmedMsg": "Jeder Käufer, der dieses Angebot sieht, weiß jetzt, dass der Preis aktuell ist.",
  "pv.thanksFlagged": "Danke für den Hinweis",
  "pv.thanksFlaggedMsg": "Wir werden den Laden bitten, den Preis erneut anzugeben.",
  "pv.couldNotSave": "Konnte das nicht speichern",
  "pv.wasItRight": "War der Preis richtig?",
  "pv.yesRight": "Ja, genau richtig",
  "pv.noChanged": "Nein, er hat sich geändert",
  "footer.cities": "Städte",
  "cities.seoTitle": "Angebote nach Stadt",
  "cities.seoDesc": "Jede Stadt mit aktuellen Angeboten auf LytePress, plus die Orte, die wir demnächst eröffnen.",
  "cities.heading": "Angebote nach Stadt",
  "cities.subline": "Wähle deine Stadt und sieh, was gerade verfügbar ist. Neue Städte erscheinen hier, sobald Geschäfte anfangen zu posten.",
  "cities.openingSoon": "Bald eröffnet",
  "city.seoTitle": "Angebote in {city}, {country}",
  "city.seoDescEmpty": "LytePress eröffnet in {city}, {country}. Kennst du ein Geschäft, das hier sein sollte? Lade sie ein.",
  "city.heading": "Angebote in {city}",
  "city.sublineEmpty": "Wir eröffnen in {city}, {country}. Noch keine Angebote hier.",
  "city.liveDeals": "{n} aktuelle Angebote",
  "city.shops": "{n} Geschäfte",
  "city.onTheMap": "Auf der Karte ansehen",
  "city.allCities": "Alle Städte",
  "city.noPage": "Noch keine Angebotsseite für diese Stadt.",
  "city.emptyTitle": "Noch nichts Aktuelles in {city}",
  "city.emptyBody": "Wir eröffnen eine Stadt, sobald ein Geschäft dort postet. Wenn du einen Ort in {city} kennst, der einen Platz auf der Karte verdient, schick sie zu uns — es dauert eine Minute und ist kostenlos.",
  "city.browseEverywhere": "Angebote überall durchstöbern",
  "city.aboutTitle": "Über Angebote in {city}",
  "city.aboutBody": "LytePress listet, was lokale Geschäfte in {city}, {country} gerade reduziert haben — hauptsächlich {cats}. Jedes Angebot zeigt den Preis, was er war, wie lange es läuft und genau, wo man hingehen muss.",
  "city.aboutTrust": "Preise tragen das Datum, an dem sie zuletzt bestätigt wurden, und Käufer, die dort waren, können anderen sagen, ob ein Preis noch gilt. Nichts hier ist ein Schätzwert.",
  "city.everyCategory": "jede Kategorie",
  "city.nearbyTitle": "Andere Städte",
  "city.otherLanguages": "Auf Deutsch lesen",
  "city.seoDesc": "{deals} von {shops} in {city}, {country}. Preise von Käufern bestätigt, täglich aktualisiert.",
  "city.subline": "{deals} von {shops} in ganz {city}, {country} — mit Preisen, die von Käufern bestätigt wurden.",
  "city.liveDealOne": "1 aktives Angebot",
  "city.shopOne": "1 Geschäft",
  "loc.following": "Standort verfolgen",
  "loc.followingLive": "Verfolge dich, während du dich bewegst",
  "loc.notFollowing": "Standort hier festgelegt",
  "loc.turnOff": "deaktivieren",
  "loc.turnOn": "folge mir wieder",
  "loc.goLive": "verfolge mich, während ich mich bewege",
  "loc.stopLive": "live verfolgen stoppen",
  "loc.nearCity": "Du bist in der Nähe von {city}",
  "loc.seeThoseDeals": "Sieh dir diese Angebote an",
  "pd.quietHours": "Ruhezeiten-Angebot",
  "pd.quietHoursHint": "Ein dauerhafter Rabatt, der sich wiederholt — wie von 15 bis 17 Uhr an Wochentagen, um die Flaute zu füllen.",
  "pd.quietFrom": "Von",
  "pd.quietTo": "Bis",
  "pd.quietNote": "Käufer sehen das Angebot auch außerhalb dieser Zeiten — es zeigt, wann es öffnet, und Codes funktionieren nur innerhalb des Zeitfensters.",
  "pd.mon": "Mo",
  "pd.tue": "Di",
  "pd.wed": "Mi",
  "pd.thu": "Do",
  "pd.fri": "Fr",
  "pd.sat": "Sa",
  "pd.sun": "So",
  "time.am": "Uhr",
  "time.pm": "Uhr",
  "qh.onUntil": "Bis {time}",
  "qh.starts": "Beginnt um {time}",
  "qh.runs": "Läuft {days}, von {from} bis {to}",
  "qh.weekdays": "Wochentage",
  "qh.weekends": "Wochenenden",
  "qh.everyDay": "jeden Tag",
  "pitch.print": "Drucke beide Seiten",
  "pitch.printHint": "Zwei Seiten: diese Stadt, dann was LytePress ist. Drucken oder als PDF speichern.",
  "pitch.cityHeading": "{city} ist bereits auf der Karte.",
  "pitch.citySub": "Das sehen Käufer in {city}, {country}, wenn sie LytePress öffnen und nach etwas suchen, für das es sich lohnt, das Haus zu verlassen.",
  "pitch.statDeals": "Aktuelle Angebote",
  "pitch.statShops": "Aufgelistete Geschäfte",
  "pitch.statTop": "Am meisten aufgelistet",
  "pitch.mapTitle": "Die Karte heute",
  "pitch.yourSpot": "Dein Platz",
  "pitch.noMapKey": "Karte nicht verfügbar",
  "pitch.alreadyOn": "Bereits hier auf LytePress",
  "pitch.claimTitle": "Es gibt eine Lücke in {city}.",
  "pitch.claimBody": "Scanne, um deinen Platz zu beanspruchen. Die Auflistung ist kostenlos, dauert etwa zwei Minuten, und dein erstes Angebot kann heute live sein.",
  "pitch.qrCityPage": "Siehe {city} Angebote",
  "pitch.qrClaim": "Beanspruche deinen Platz",
  "pitch.aboutHeading": "Was LytePress ist.",
  "pitch.aboutLine": "Eine Karte mit echten Angeboten von echten Geschäften. Käufer öffnen sie, um zu sehen, was gerade in ihrer Nähe reduziert ist — und jeder Preis trägt das Datum, an dem jemand zuletzt dafür stand.",
  "pitch.mapCaption": "Jeder Pin ist ein Geschäft mit einem aktuellen Angebot.",
  "pitch.forShoppers": "Für Käufer",
  "pitch.shopper1": "Sieh, was in Gehweite gerade reduziert ist, mit Wegbeschreibung zur Tür.",
  "pitch.shopper2": "Jeder Preis zeigt, wann er zuletzt bestätigt wurde — vom Geschäft oder von einem Käufer, der gerade dort war.",
  "pitch.shopper3": "Lebensmittel kurz vor dem Ablaufdatum und kurz datierte Bestände an einem Ort, damit gutes Essen gegessen und nicht weggeworfen wird.",
  "pitch.forShops": "Für Geschäfte",
  "pitch.shop1": "Die Auflistung ist kostenlos. Du postest ein Angebot, es erscheint auf der Karte und auf der Seite deiner Stadt.",
  "pitch.shop2": "Bewege Bestände, die kurz vor dem Ablaufdatum stehen, anstatt sie abzuschreiben.",
  "pitch.shop3": "Fülle deine Ruhezeiten mit einem dauerhaften Rabatt, der nur im von dir gewählten Zeitfenster läuft.",
  "pitch.howTitle": "So funktioniert es",
  "pitch.how1": "Melde dich als Geschäft an und setze einen Pin, wo du tatsächlich bist.",
  "pitch.how2": "Poste dein Angebot — ein Foto, den Preis und wie lange es läuft.",
  "pitch.how3": "Käufer in der Nähe sehen es, gehen rein und zeigen einen Code, den du an der Kasse überprüfst.",
  "pitch.startTitle": "Beginne mit einem Angebot.",
  "pitch.startBody": "Scanne das, melde dich an und setze ein Angebot auf die Karte. Wenn niemand kommt, hast du zwei Minuten verloren.",
  "pitch.qrStart": "Melde deinen Laden an",
  "pitch.exampleTitle": "So sieht eine Woche in {city} aus",
  "pitch.exampleTag": "Beispiel",
  "pitch.demoNote": "Die Pins und Einträge oben sind Beispiele — {city} ist offen und wartet auf seine ersten Geschäfte.",
  "pitch.mapCaptionDemo": "Beispiel-Pins — so sieht eine Stadt aus, wenn Geschäfte anfangen, Angebote zu posten.",
  "pitch.cityHeadingDemo": "{city} ist als Nächstes auf der Karte.",
  "pitch.citySubDemo": "LytePress eröffnet in {city}, {country}. Das werden die Käufer hier sehen – und so würde dein eigenes Angebot aussehen.",
  "pitch.sellFreeN": "Kostenlos",
  "pitch.sellFree": "Um deine Angebote aufzulisten",
  "pitch.sellFastN": "2 Min.",
  "pitch.sellFast": "Um deinen Shop anzumelden",
  "pitch.sellLiveN": "Heute",
  "pitch.sellLive": "Dein erstes Angebot wird live",
  "pd.shortDatedHint": "Für Waren, die kurz vor dem Haltbarkeitsdatum oder Ablaufdatum stehen - Lebensmittel, Getränke, Nahrungsergänzungsmittel, Medikamente, Kosmetika, Motoröl, Batterien, Samen, Tinte. Käufer sehen ein Kurzfristig-Schild; Offenheit verkauft schneller und reduziert Abfall.",
  "pc.giftedNote": "Geschenkt von uns. Die datierten werden zuerst eingelöst.",
  "pc.giftedHeld": "Geschenkte Extras",
  "pc.giftedUseBy": "Verwende {n} vor {date}",
  "lo.title": "Ein Dankeschön von LytePress",
  "lo.credits": "{n} zusätzliche Angebote sind bereits auf deinem Konto.",
  "lo.neverExpires": "Sie laufen nie ab.",
  "lo.useBy": "Verwende sie vor {date}.",
  "lo.codeLine": "Und {off} Rabatt auf {what} mit deinem Code.",
  "lo.codeValid": "Nur für dich, einmalig, bis {date}.",
  "lo.useIt": "Verwende es",
  "lo.seePlans": "Pläne ansehen",
  "lo.copy": "Code kopieren",
  "lo.pkgPro": "Pro monatlich",
  "lo.pkgProYear": "Pro jährlich",
  "lo.pkgElite": "Elite monatlich",
  "lo.pkgEliteYear": "Elite jährlich",
  "lo.pendingTitle": "Ein Paket für deinen Laden",
  "lo.pendingWhat": "Enthält {what}",
  "lo.pay": "{price} bezahlen",
  "lo.paying": "Zahlung wird geöffnet…",
  "lo.invoiceMonthly": "{price} — monatliche Abrechnung, wir stellen eine Rechnung.",
  "lo.payFailed": "Zahlung konnte nicht geöffnet werden. Bitte erneut versuchen.",
  "lo.pkgPlan": "dein Plan",
  "lo.titleSoon": "Nur noch {n} Tage, um dies zu nutzen",
  "vf.body": "Sende uns deine Geschäftsdokumente und wir fügen deinem Profil ein blaues verifiziertes Abzeichen hinzu. Käufer vertrauen verifizierten Shops mehr – und es schaltet jede Kategorie frei.",
  "vf.regPlaceholder": "Registrierungsnummer (optional)",
  "qa.needs_verification": "„{category}“-Angebote können nur von einem verifizierten Unternehmen gepostet werden. Lass dich über Mein Konto verifizieren – normalerweise innerhalb eines Tages.",
  "trust.verifiedBody": "Von unserem Team genehmigt.",
  "trust.independentBody": "Noch nicht genehmigt – aber viele großartige lokale Verkäufer starten hier. Ihre Angebote werden weiterhin auf Qualität geprüft.",
  "browse.nothingWithin": "Gerade nichts innerhalb von {radius}",
  "browse.nothingWithinMsg": "Kein laufendes Angebot hat einen Pin innerhalb von {radius} um dich. Statt die Seite mit Läden zu füllen, die du nicht erreichst, hier die ehrliche Antwort — und zwei Wege, die Suche zu erweitern.",
  "browse.showFurther": "{n} weiter entfernte Angebote zeigen",
  "browse.hideFurther": "Weiter entfernte Angebote ausblenden",
  "browse.furtherNote": "Diese liegen weiter als {radius} entfernt, die nächsten zuerst.",
  "browse.browseCountry": "Im ganzen Land stöbern",
  "mt.title": "Wir sind gleich zurück",
  "mt.body": "LytePress wird planmäßig aktualisiert. Dein Konto ist nicht betroffen — Angebote, Guthaben und Codes sind genau dort, wo du sie gelassen hast.",
  "mt.backIn": "Wieder online in",
  "mt.backAt": "Voraussichtlich zurück um {time}",
  "mt.soon": "Wir sind jeden Moment zurück.",
  "mt.staff": "Team-Anmeldung",
  "mt.readonly": "Geplante Wartung: Stöbern geht, Veröffentlichen und Zahlungen sind pausiert.",
  "mt.notice": "Geplante Wartung {when} — die Seite kann kurz nicht erreichbar sein.",
  "mt.adminOn": "Der Wartungsmodus ist AKTIV — alle außer Admins sind ausgesperrt.",
  "prc.usdNote": "Abrechnung in US-Dollar. Läuft deine Karte in einer anderen Währung, rechnet deine Bank zu ihrem eigenen Kurs um — auf der Abrechnung kann daher ein leicht anderer Betrag stehen.",
  "prc.feeNote": "Deine Bank kann Währungsumrechnungs- oder Transaktionsgebühren erheben.",
  "lg.availabilityTitle": "Verfügbarkeit des Dienstes & geplante Wartung",
  "lg.availabilityBody": "LytePress wird regelmäßig aktualisiert. Software-Updates und Wartung finden in Intervallen statt, und der Zugriff auf die Website, die App oder dein Dashboard kann während dieser Arbeiten zeitweise nicht möglich sein.\n\nWenn Arbeiten geplant sind und den Dienst wahrscheinlich unterbrechen, weisen wir vorab in der App darauf hin und legen sie möglichst in ruhige Stunden. Kurze geplante oder ungeplante Ausfälle gehören zum normalen Betrieb eines Onlinedienstes und begründen für sich allein keinen Anspruch auf Rückerstattung. Lief ein bezahlter Boost oder eine bezahlte Hervorhebung wegen eines Ausfalls auf unserer Seite nicht, erstatten oder gutschreiben wir diese Platzierung — schreib an support@lytepress.com und wir regeln das.",
  "lg.forceMajeureTitle": "Höhere Gewalt",
  "lg.forceMajeureBody": "Weder du noch LytePress sind dafür verantwortlich, eine Pflicht aus diesen Bedingungen nicht zu erfüllen, wenn die Ursache außerhalb der zumutbaren Kontrolle liegt. Dazu gehören Stürme, Hurrikane, Überschwemmungen, Erdbeben, Feuer, Epidemien oder Pandemien, Krieg, Unruhen, Streiks, Handlungen oder Anordnungen einer Regierung oder Behörde, Ausfall von Strom oder Internet sowie der Ausfall oder die Sperrung eines Drittanbieters, auf den wir angewiesen sind — etwa Hosting-, Zahlungs-, Karten- oder E-Mail-Dienste.\n\nSolange ein solches Ereignis andauert, sind die betroffenen Pflichten ausgesetzt und nicht verletzt, und wir stellen den normalen Betrieb so schnell wie zumutbar möglich wieder her. Hält ein solches Ereignis den Dienst länger als 30 Tage in Folge außer Betrieb, kann jede Seite ein bezahltes Abo beenden; den nicht genutzten Teil der Laufzeit erstatten wir.",
};

export default de;
